import React, { useState, useEffect } from "react";

import emerald from "../../assets/images/emerald.jpg";
import Roundimg from "../../assets/images/Round_65x65.jpg";
import RadiantImg from "../../assets/images/Radiant.jpg";
import PrincessImg from "../../assets/images/Princess.jpg";
import PearImg from "../../assets/images/Pear.jpg";
import OvalImg from "../../assets/images/Oval.jpg";
import MarquiseImg from "../../assets/images/Marquise.jpg";
import HeartImg from "../../assets/images/Heart.jpg";
import EmeraldImg from "../../assets/images/emerald.jpg";
import CushionImg from "../../assets/images/Cushion.jpg";
import AsscherImg from "../../assets/images/Asscher.jpg";

import Blue from "../../assets/images/Blue.png";
import Pink from "../../assets/images/Pink.png";
import Yellow from "../../assets/images/Yellow.png";
import Brown from "../../assets/images/Brown.png";
import Green from "../../assets/images/Green.png";
import Gray from "../../assets/images/Gray.png";
import Black from "../../assets/images/Black.png";
import Red from "../../assets/images/Red.png";
import Purple from "../../assets/images/Purple.png";
import Chameleon from "../../assets/images/Chameleon.png";
import Violet from "../../assets/images/Violet.png";

import Filter_icon from "../../assets/images/filter_icon.png";
import ImageIcon from "../../assets/images/imageIcon.png";
import CatalogDiamondDataService from "../../services/catalog-diamond.service";
import AppsRingBuilderService from "../../services/apps-ringbuilder.service";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import searchDiamondService from "../../services/search-diamond.service";
import catalogDiamondService from "../../services/catalog-diamond.service";

import space__icon from "../../assets/images/space__icon.png";
import { NotificationManager } from "react-notifications";
import {
  Button,
  Col,
  Empty,
  Input,
  Modal,
  Row,
  Select,
  Slider,
  Switch,
  Table,
  Tooltip,
} from "antd";

const ColorDiamondSearch = () => {
  const { t } = useTranslation();
  const { Search } = Input;
  const initialCertInfoData = {
    name: "",
    email: "",
    phoneNumber: "",
    comments: "",
  };
  const initialCertInfoValidation = {
    nameVal: "",
    emailVal: "",
    phoneNumberVal: "",
    commentsVal: "",
  };
  const [requestCertModalLoading, setRequestMoreCertModalLoading] =
    useState(false);
  const [requestCertModal, setRequestMoreCertModal] = useState(false);
  const [requestInfoDetails, setRequestInfoDetails] = useState({
    intDiamondId: "",
    dealerID: "",
  });
  const [certInfoValidation, setcertInfoDataValidation] = useState(
    initialCertInfoValidation
  );
  const [certInfoData, setcertInfoData] = useState(initialCertInfoData);
  const [showMoreFilter, setShowMoreFilter] = useState(false);
  const [selectedColumnId, setSelectedColumnId] = useState(0);
  const initialViewMyColorData = {
    colors: [],
    colorIsSelected: {
      Blue: false,
      Pink: false,
      Yellow: false,
      Brown: false,
      Green: false,
      Gray: false,
      Black: false,
      Red: false,
      Purple: false,
      Chameleon: false,
      Violet: false,
      All: false,
    },
    Shapes: [],
    ShapeIsSelected: {
      Round: false,
      Radiant: false,
      Princess: false,
      Pear: false,
      Oval: false,
      Marquise: false,
      Heart: false,
      Emerald: false,
      Cushion: false,
      Asscher: false,
      All: false,
    },
    permission: [],
    minCarat: 0,
    maxCarat: 20,
    fancyIntensity: "",
    overtone1: [],
    overtone2: [],
    clarityFrom: "Any",
    clarityTo: "Any",
    polishTo: null,
    polishFrom: null,
    symmetryFrom: null,
    symmetryTo: null,
    cutFrom: null,
    cutTo: null,
    minOverallPrice: 0,
    maxOverallPrice: 100000,
    minPriceperCaretRange: 0,
    maxPriceperCaretRange: 100000,
    minLWRatioMeasurements: 0,
    maxLWRatioMeasurements: 1000,
    location: null,
    eyeClean: [],
    fluorescenceIntensityFrom: null,
    fluorescenceIntensityTo: null,
    fluorescenceColor: [],
    dealers: [],
    certificates: [],
    lengthFrom: null,
    lengthTo: null,
    widthFrom: null,
    widthTo: null,
    heightFrom: null,
    heightTo: null,

    Radio: "",
    shade: [],
    centralInclusionRange: [],
    blackInclusionRange: [],
    milkyInclusionRange: [],
    girdleRangeFrom: null,
    girdleRangeTo: null,
    crownAngleRangeFrom: 0,
    crownAngleRangeTo: 100,
    pavilionAngleRangeFrom: 0,
    pavilionAngleRangeTo: 100,
    keytoSymbols: [],
    culetRangeFrom: null,
    culetRangeTo: null,
    culetConditionRangeFrom: null,
    culetConditionRangeTo: null,
    treatment: [],
    depthFrom: "0",
    depthTo: "100",
    tableFrom: "0",
    tableTo: "100",
    matchedPairs: [],
    hasVideo: false,
  };

  const [state, setState] = useState(initialViewMyColorData);
  const [isModalVisibleFullscreen, setIsModalVisibleFullscreen] =
    useState(false);
  const [
    permissionsForDiamondCatalogList,
    setPermissionsForDiamondCatalogList,
  ] = useState([]);
  const [dealersForDiamondCatalogList, setDealersForDiamondCatalogList] =
    useState([]);
  const [fancyDiamondList, setFancyDiamondList] = useState([]);
  const [
    certificatesForDiamondCatalogList,
    setCertificatesForDiamondCatalogList,
  ] = useState([]);
  const [overToneForDiamondCatalogList, setOverToneForDiamondCatalogList] =
    useState([]);
  const [fancyIntensityList, setFancyIntensityList] = useState([]);
  const [locationsForDiamondCatalogList, setLocationsForDiamondCatalogList] =
    useState([]);
  const [diamondPolishList, setDiamondPolishList] = useState([]);
  const [diamondSymmetryList, setDiamondSymmetryList] = useState([]);
  const [diamondCutGradeList, setDiamondCutGradeList] = useState([]);
  const [diamondClarityList, setClarityList] = useState([]);
  const [diamondFluorescenceColorList, setDiamondFluorescenceColorList] =
    useState([]);
  const [disableBtn, setDisableBtn] = useState(true);

  const [caratSlideValue, setCaratSlideValue] = useState([0, 20]);
  const [overallPriceValue, setOverallPriceValue] = useState([0, 100000]);
  const [pricePerCaratValue, setPricePerCaratValue] = useState([0, 100000]);
  const [lWRatioMeasurementsValue, setLRatioMeasurementsValue] = useState([
    0, 1000,
  ]);

  const { Option } = Select;
  const [hideShowFilter, setHideShowFilter] = useState(true);

  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [gridLoading, setGridLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);

  const [ViewMyColorData, setViewMyColorData] = useState(
    initialViewMyColorData
  );
  const [msgData, setMsgData] = useState("");
  const [msgLoading, setMsgLoading] = useState(false);
  const [msgError, setMsgError] = useState("");
  const [selectedRowDetails, setSelectedRowDetails] = useState({});
  const [isVideo, setIsVideo] = useState(false);
  const [videoImageModal, setVideoImageModal] = useState(false);

  const [isEmail, setIsEmail] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [emailCertificat, setEmailCertificat] = useState({});
  const [errorEmailCertificat, setErrorEmailCertificat] = useState({});
  const [EmailLoading, setEmailLoading] = useState(false);
  const [validation, setValidation] = useState({
    crownAngleRangeFromVal: "",
    crownAngleRangeToVal: "",
  });
  const [btnValue, setBtnValue] = useState(1);
  const [sortColumnName, setSortColumnName] = useState("tmpColumn Asc");
  const [sortType, setSortType] = useState("Asc");
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [dealerId, setDealerId] = useState();
  const [currencySign, setCurrencySign] = useState("$");
  const [currencySymbol, setCurrencySymbol] = useState("USD");

  const [searchText, setSearchText] = useState("");

  const handleSendFriendemail = () => {
    try {
      let inputData = {
        name: emailCertificat.Name,
        email: emailCertificat.Email,
        friendsName: emailCertificat.FriendsName,
        friendsEmail: emailCertificat.FriendsEmail,
        comments: emailCertificat.Comments,
        dealerID: parseInt(dealerId),
        dInventoryID: parseInt(selectedRowDetails.intDiamondId),
      };
      setEmailLoading(true);
      CatalogDiamondDataService.SendFriendemail(inputData)
        .then((response) => {
          var message = response.data.message;

          if (message === "Success") {
            setEmailLoading(false);
            setVisible3(false);
            NotificationManager.success(t("Mail sent successfully."));
          } else {
            setEmailLoading(false);
            NotificationManager.error(t("Mail not sent."));
          }
        })
        .catch((error) => {
          setEmailLoading(false);
          console.log(error);
        });
    } catch (error) {
      setEmailLoading(false);
      console.log(error);
    }
    emailCertificat.Name = "";
    emailCertificat.Email = "";
    emailCertificat.FriendsName = "";
    emailCertificat.FriendsEmail = "";
    emailCertificat.Comments = "";
    setEmailCertificat((prevState) => ({
      ...prevState,
      ...emailCertificat,
    }));
  };

  const handleOpenIsEmail = () => {
    setIsEmail(true);
  };
  const handleCloseIsEmail = () => {
    setIsEmail(false);
    emailCertificat.Name = "";
    emailCertificat.Email = "";
    emailCertificat.FriendsName = "";
    emailCertificat.FriendsEmail = "";
    emailCertificat.Comments = "";
    setEmailCertificat((prevState) => ({
      ...prevState,
      ...emailCertificat,
    }));
  };
  const handleEmailCertificatChange = (e) => {
    const { name, value } = e.target;
    emailCertificat[name] = value;
    errorEmailCertificat[name] = null;
    setEmailCertificat((prevState) => ({
      ...prevState,
      ...emailCertificat,
    }));
    setErrorEmailCertificat((prevState) => ({
      ...prevState,
      ...errorEmailCertificat,
    }));
  };
  const handleValidEmailCertificat = () => {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    var isValid = true;
    var tempEmailCertificat = emailCertificat;
    var tempErrorEmailCertificat = errorEmailCertificat;
    if (!tempEmailCertificat["Name"]) {
      tempErrorEmailCertificat["Name"] = t("Enter Name.");
      isValid = false;
    } else {
      tempErrorEmailCertificat["Name"] = null;
    }

    if (!tempEmailCertificat["Email"]) {
      tempErrorEmailCertificat["Email"] = t("Enter Email Address.");
      isValid = false;
    } else if (!tempEmailCertificat["Email"].trim()) {
      tempErrorEmailCertificat["Email"] = t("Enter Email Address.");
      isValid = false;
    } else if (regex.test(tempEmailCertificat["Email"]) === false) {
      tempErrorEmailCertificat["Email"] = t("Email is not valid.");
      isValid = false;
    }

    if (!tempEmailCertificat["FriendsName"]) {
      tempErrorEmailCertificat["FriendsName"] = t("Enter Friend's Name.");
      isValid = false;
    } else {
      tempErrorEmailCertificat["FriendsName"] = null;
    }

    if (!tempEmailCertificat["FriendsEmail"]) {
      tempErrorEmailCertificat["FriendsEmail"] = t(
        "Enter Friend's Email Address."
      );
      isValid = false;
    } else if (!tempEmailCertificat["FriendsEmail"].trim()) {
      tempErrorEmailCertificat["FriendsEmail"] = t(
        "Enter Friend's Email Address."
      );
      isValid = false;
    } else if (regex.test(tempEmailCertificat["Email"]) === false) {
      tempErrorEmailCertificat["FriendsEmail"] = t("Email is not valid.");
      isValid = false;
    }

    setErrorEmailCertificat((prevState) => ({
      ...prevState,
      ...tempErrorEmailCertificat,
    }));
    return isValid;
  };

  const handleCertificateEmailSend = () => {
    if (handleValidEmailCertificat()) {
      handleSendFriendemail();
    }
  };

  const handleSendMsg = () => {
    try {
      let inputData = {
        dealrId: selectedRowDetails.dealerID,
        msg: msgData,
        intDiamondId: selectedRowDetails.intDiamondId,
      };
      setMsgLoading(true);
      CatalogDiamondDataService.SendMsg(inputData)
        .then((response) => {
          var message = response.data.message;

          setMsgLoading(false);

          if (message === "Success") {
            setVisible1(false);
            NotificationManager.success(t("Message sent successfully."));
          } else {
            NotificationManager.error(t("Message not sent."));
          }
        })
        .catch((error) => {
          setMsgLoading(false);
          console.log(error);
        });
    } catch (error) {
      setMsgLoading(false);
      console.log(error);
    }
  };

  const handleMsgValidation = () => {
    if (msgData) {
      if (msgData.trim() === "") {
        setMsgError(t("Please enter message."));
      } else {
        handleSendMsg();
      }
    } else {
      setMsgError(t("Please enter message."));
    }
  };

  const handleCancel1 = () => {
    setVisible1(false);
    setMsgData("");
    setMsgError("");
  };
  const handleOk1 = (item) => {
    setSelectedRowDetails(item);
    setMsgData("");
    setMsgError("");
    setVisible1(true);
  };

  const handleOpenVideoImageModal = (row, isVideo) => {
    setIsVideo(isVideo);
    setSelectedRowDetails(row);
    setVideoImageModal(true);
  };

  const handleCloseVideoImageModal = () => {
    setVideoImageModal(false);
  };

  const handleOnChangeRadio = (event) => {
    if (
      validation.crownAngleRangeFromVal === "" &&
      validation.crownAngleRangeToVal === ""
    ) {
      setDisableBtn(false);
      setBtnValue(1);
    } else {
      setDisableBtn(true);
      setBtnValue(0);
    }
    setViewMyColorData({
      ...ViewMyColorData,
      Radio: event.target.name,
    });
  };
  const handleOnChange = (e, isSelect, name) => {
    setDisableBtn(false);
    if (isSelect === "select") {
      let updatedValue = e;
      if (name === "certificates") {
        if (updatedValue.includes("0") && updatedValue.length > 1) {   
          const wasSearchAllPreviouslySelected = ViewMyColorData[name] && ViewMyColorData[name].includes("0");
          if (!wasSearchAllPreviouslySelected) { 
            updatedValue = ["0"];
          } else {
            updatedValue = updatedValue.filter(value => value !== "0");
          }
        }
      }
      
      setViewMyColorData({
        ...ViewMyColorData,
        [name]: updatedValue,
      });
    } else {
      const value = e.target.value;
      const key = e.nativeEvent.data;

      const rangedFields = ["crownAngleRangeTo", "crownAngleRangeFrom"];
      if (["e", "E", "+", "-"].includes(key)) {
        return; // don't update state
      }
      if (rangedFields.includes(e.target.name)) {
        if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
          setViewMyColorData({
            ...ViewMyColorData,
            [e.target.name]: e.target.value,
          });
        }
      } else {
        setViewMyColorData({
          ...ViewMyColorData,
          [e.target.name]: e.target.value,
        });
      }

      setValidation(validation);
      if (
        validation.crownAngleRangeFromVal === "" &&
        validation.crownAngleRangeToVal === ""
      ) {
        setDisableBtn(false);
        setBtnValue(1);
      } else {
        setDisableBtn(true);
        setBtnValue(0);
      }
    }
  };

  const onNumberChange = (e, name) => {
    if (
      validation.crownAngleRangeFromVal === "" &&
      validation.crownAngleRangeToVal === ""
    ) {
      setDisableBtn(false);
      setBtnValue(1);
    } else {
      setDisableBtn(true);
      setBtnValue(0);
    }
    let tempState = { ...ViewMyColorData };
    tempState[name] = e.target.value;

    setViewMyColorData((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  };

  const handleOk = () => {
    setVisible1(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleCancel2 = () => {
    setVisible2(false);
  };

  const handleHideShowFilter = () => {
    setHideShowFilter(!hideShowFilter);
  };

  /*Custom Binding Starts*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.responseData) {
        setDealerId(loginDetials.responseData.dealerId);
        handleGetDynamicData(loginDetials.responseData.dealerId);
        handleGetDealersForDiamondCatalogList(
          loginDetials.responseData.dealerId
        );
        handleGetFancyDiamondList(
          loginDetials.responseData.dealerId,
          pageNo,
          pageSize,
          sortColumnName,
          sortType
        );
      }
    }
  }, []);

  // Helper function to get clarityID from claritydetails
  // Using index+1 because API clarityIDs are wrong (all 0)
  const getClarityId = (clarityName) => {
    if (!clarityName || clarityName === "Any") return "-1";
    const index = diamondClarityList.findIndex(item => item.claritydetails === clarityName);
    return index >= 0 ? (index + 1).toString() : "-1";
  };

  const handleGetFancyDiamondList = async (
    dealerId,
    pageNo,
    pageSize,
    sortColumnName,
    sortType,
    isReset,
    searchVal
  ) => {
    setPageNo(pageNo);
    setPageSize(pageSize);
    let tempshapes = Object.keys(state.ShapeIsSelected)
      .filter((k) => state.ShapeIsSelected[k] === true)
      .map((x) => x)
      .join(",");
    let inputData = {
      dealerId: dealerId.toString(),
      shapes: isReset ? "" : tempshapes,
      colorMin: "-1",
      colorMax: "-1",
      clarityMin: isReset ? "-1" : getClarityId(ViewMyColorData.clarityFrom),
      clarityMax: isReset ? "-1" : getClarityId(ViewMyColorData.clarityTo),
      caratMin: isReset ? "0" : caratSlideValue[0] + "", //"0",
      caratMax: isReset ? "20" : caratSlideValue[1] + "", //"20",
      priceMin: isReset ? "0" : overallPriceValue[0] + "",
      priceMax: isReset ? "100000" : overallPriceValue[1] + "",
      certificate: isReset ? "" : ViewMyColorData.certificates + "",
      cutGradeMin: isReset
        ? "-1"
        : ViewMyColorData.cutFrom === null
          ? "-1"
          : ViewMyColorData.cutFrom.toString(),
      cutGradeMax: isReset
        ? "-1"
        : ViewMyColorData.cutTo === null
          ? "-1"
          : ViewMyColorData.cutTo.toString(),
      symmetryMin: isReset
        ? "-1"
        : ViewMyColorData.symmetryFrom === null
          ? "-1"
          : ViewMyColorData.symmetryFrom.toString(),
      symmetryMax: isReset
        ? "-1"
        : ViewMyColorData.symmetryTo === null
          ? "-1"
          : ViewMyColorData.symmetryTo.toString(),
      polishMin: isReset
        ? "-1"
        : ViewMyColorData.polishFrom === null
          ? "-1"
          : ViewMyColorData.polishFrom.toString(),
      polishMax: isReset
        ? "-1"
        : ViewMyColorData.polishTo === null
          ? "-1"
          : ViewMyColorData.polishTo.toString(),
      depthMin: isReset ? "0" : ViewMyColorData.depthFrom === "" ? "0" : ViewMyColorData.depthFrom.toString(),
      depthMax: isReset ? "100" : ViewMyColorData.depthTo === "" ? "100" : ViewMyColorData.depthTo.toString(),
      tableMin: isReset ? "0" : ViewMyColorData.tableFrom === "" ? "0" : ViewMyColorData.tableFrom.toString(),
      tableMax: isReset ? "100" : ViewMyColorData.tableTo === "" ? "100" : ViewMyColorData.tableTo.toString(),
      fluorescenceMin: isReset
        ? "-1"
        : ViewMyColorData.fluorescenceIntensityFrom === null
          ? "-1"
          : ViewMyColorData.fluorescenceIntensityFrom,
      fluorescenceMax: isReset
        ? "-1"
        : ViewMyColorData.fluorescenceIntensityTo === null
          ? "-1"
          : ViewMyColorData.fluorescenceIntensityTo,
      pairCode: "",
      orderBy:
        sortColumnName == "txtStockNo"
          ? "DealerInventoryNo"
          : sortColumnName == "txtShape"
            ? "Cut"
            : sortColumnName == "fltCarat"
              ? "Size"
              : sortColumnName == "txtCulet"
                ? "CutGrade"
                : sortColumnName == "txtFancyColorMainBody"
                  ? "Color"
                  : sortColumnName == "txtClarity"
                    ? "Clarity"
                    : sortColumnName == "fltRapPercent"
                      ? "OffRapaport"
                      : sortColumnName == "fltPrice"
                        ? "FltPrice"
                        : sortColumnName == "fltDepth"
                          ? "Depth"
                          : sortColumnName == "fltTable"
                            ? "TableMeasure"
                            : sortColumnName == "txtCertificate"
                              ? "Certificate"
                              : sortColumnName == "txtSymmetry"
                                ? "Symmetry"
                                : sortColumnName == "dealer"
                                  ? "DealerID"
                                  : sortColumnName == "txtFluorescence"
                                    ? "Flouresence"
                                    : sortColumnName == "txtMeasurements"
                                      ? "Measurements"
                                      : sortColumnName == "txtPolish"
                                        ? "Polish"
                                        : sortColumnName == "realPrice"
                                          ? "tmpColumn"
                                          : "tmpColumn",
      orderType: sortType ? sortType : "Asc",
      pageNumber: pageNo + "",
      pageSize: pageSize + "",
      invenID: "",
      strDetailLinkURL: "dealerlink",
      caratPriceMin: isReset ? "0" : pricePerCaratValue[0] + "", // "0",
      caratPriceMax: isReset ? "100000" : pricePerCaratValue[1] + "", // "100000",
      ratioMin: isReset ? "0" : lWRatioMeasurementsValue[0] + "", // "0",
      ratioMax: isReset ? "0" : lWRatioMeasurementsValue[1] + "", //"1000",
      polishList: isReset
        ? "-1"
        : ViewMyColorData.polishFrom === null &&
          ViewMyColorData.polishTo === null
          ? "-1"
          : "",
      symmetryList: isReset
        ? "-1"
        : ViewMyColorData.symmetryFrom === null &&
          ViewMyColorData.symmetryTo === null
          ? "-1"
          : "",
      fluorescenceList: isReset
        ? "-1"
        : ViewMyColorData.fluorescenceIntensityFrom === null &&
          ViewMyColorData.fluorescenceIntensityTo === null
          ? "-1"
          : "",
      cutGradeList: isReset
        ? "-1"
        : ViewMyColorData.cutFrom === null && ViewMyColorData.cutTo === null
          ? "-1"
          : "",
      colorList: "-1",
      clarityList: isReset
        ? "-1"
        : getClarityId(ViewMyColorData.clarityFrom) === "-1" &&
          getClarityId(ViewMyColorData.clarityTo) === "-1"
          ? "-1"
          : "",
      sOrigin: "",
      intOptimize: 0,
      intCulet1: isReset
        ? 0
        : ViewMyColorData.culetRangeFrom === null
          ? 0
          : parseInt(ViewMyColorData.culetRangeFrom),
      intCulet2: isReset
        ? 20
        : ViewMyColorData.culetRangeTo === null
          ? 20
          : parseInt(ViewMyColorData.culetRangeTo),
      intCuletCondition1: isReset
        ? 0
        : ViewMyColorData.culetConditionRangeFrom === null
          ? 0
          : parseInt(ViewMyColorData.culetConditionRangeFrom),
      intCuletCondition2: isReset
        ? 20
        : ViewMyColorData.culetConditionRangeTo === null
          ? 20
          : parseInt(ViewMyColorData.culetConditionRangeTo),
      fltCrownAngle1: isReset
        ? 0
        : ViewMyColorData.crownAngleRangeFrom === ""
          ? 0
          : parseInt(ViewMyColorData.crownAngleRangeFrom),
      fltCrownAngle2: isReset
        ? 100
        : ViewMyColorData.crownAngleRangeTo === ""
          ? 100
          : parseInt(ViewMyColorData.crownAngleRangeTo),
      fltPavilionAngle1: isReset
        ? 0
        : ViewMyColorData.pavilionAngleRangeFrom === ""
          ? 0
          : parseInt(ViewMyColorData.pavilionAngleRangeFrom),
      fltPavilionAngle2: isReset
        ? 100
        : ViewMyColorData.pavilionAngleRangeTo === ""
          ? 100
          : parseInt(ViewMyColorData.pavilionAngleRangeTo),
      intGirdle1: isReset
        ? -1
        : ViewMyColorData.girdleRangeFrom === null
          ? -1
          : parseInt(ViewMyColorData.girdleRangeFrom),
      intGirdle2: isReset
        ? -1
        : ViewMyColorData.girdleRangeTo === null
          ? -1
          : parseInt(ViewMyColorData.girdleRangeTo),
      intCutGrade: 0,
      uploadDateMin: "",
      uploadDateMax: "",
      strSelectedDealers: isReset ? "" : ViewMyColorData.dealers + "",
      selectedDealerConunt: 1,
      fancyColor: isReset ? "" : colorData === "," ? "" : colorData,
      intIntensity: isReset
        ? -1
        : ViewMyColorData.fancyIntensity === ""
          ? -1
          : parseInt(ViewMyColorData.fancyIntensity),
      overtone: isReset ? "" : ViewMyColorData.overtone1 + "",
      overtone2: isReset ? "" : ViewMyColorData.overtone2 + "",
      strMatchedPairs: isReset ? "" : ViewMyColorData.matchedPairs.toString(),
      fltWidth1: isReset
        ? "-1"
        : ViewMyColorData.widthFrom === null
          ? "-1"
          : ViewMyColorData.widthFrom?.toString(),
      fltWidth2: isReset
        ? "-1"
        : ViewMyColorData.widthTo === null
          ? "-1"
          : ViewMyColorData.widthTo?.toString(),
      fltHeight1: isReset
        ? "-1"
        : ViewMyColorData.heightFrom === null
          ? "-1"
          : ViewMyColorData.heightFrom?.toString(),
      fltHeight2: isReset
        ? "-1"
        : ViewMyColorData.heightTo === null
          ? "-1"
          : ViewMyColorData.heightTo?.toString(),
      fltLength1: isReset
        ? "-1"
        : ViewMyColorData.lengthFrom === null
          ? "-1"
          : ViewMyColorData.lengthFrom?.toString(),
      fltLength2: isReset
        ? "-1"
        : ViewMyColorData.lengthTo === null
          ? "-1"
          : ViewMyColorData.lengthTo?.toString(),
      strSelectedInvID: "",
      flagDD: "0",
      checkInventory: "Catalog",
      country: isReset
        ? ""
        : ViewMyColorData.location === null
          ? ""
          : ViewMyColorData.location,
      shade: isReset ? "" : ViewMyColorData.shade + "",
      treatment: isReset ? "" : ViewMyColorData.treatment + "",
      keytosymbol: isReset ? "" : ViewMyColorData.keytoSymbols + "",
      fluorescenceColor: isReset ? "" : ViewMyColorData.fluorescenceColor + "",
      blackInclusion: isReset ? "" : ViewMyColorData.blackInclusionRange + "",
      centralInclusion: isReset
        ? ""
        : ViewMyColorData.centralInclusionRange + "",
      milkyInclusion: isReset ? "" : ViewMyColorData.milkyInclusionRange + "",
      eyeclean: isReset ? "" : ViewMyColorData.eyeClean + "",
      ratioType: isReset ? "" : ViewMyColorData.Radio,
      permission: isReset
        ? ""
        : ViewMyColorData.permission === null
          ? ""
          : ViewMyColorData.permission.toString(),
      video: isReset ? "0" : ViewMyColorData.hasVideo === true ? "1" : "0",
      did: searchVal ? searchVal : "",
    };
    setGridLoading(true);
    try {
      await searchDiamondService
        .GetALLFancyDiamondList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setFancyDiamondList(responseData);
              if (responseData.length > 0) {
                setTotalCount(responseData[0].intTotalRecords);
              } else {
                setTotalCount(0);
              }
              setGridLoading(false);
            } else {
              setFancyDiamondList([]);
              setGridLoading(false);
            }
          } else {
            setFancyDiamondList([]);
          }
        })
        .catch((error) => {
          setGridLoading(false);
          console.log(error);
        });
    } catch (error) {
      setGridLoading(false);
      console.log(error);
    }
  };

  const handleGetPermissionsForDiamondCatalogList = async () => {
    try {
      let inputData = {
        type: "",
      };
      await CatalogDiamondDataService.GetPermissionsForDiamondCatalogList(
        inputData
      )
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          handleGetOverToneForDiamondCatalogList();
          if (message === "Success") {
            if (responseData) {
              setPermissionsForDiamondCatalogList(responseData);
            } else {
              setPermissionsForDiamondCatalogList([]);
            }
          } else {
            setPermissionsForDiamondCatalogList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetLocationsForDiamondCatalogList = async () => {
    try {
      let inputData = {
        type: "",
      };
      await CatalogDiamondDataService.GetLocationsForDiamondCatalogList(
        inputData
      )
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setLocationsForDiamondCatalogList(responseData);
            } else {
              setLocationsForDiamondCatalogList([]);
            }
          } else {
            setLocationsForDiamondCatalogList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetDealersForDiamondCatalogList = async (id) => {
    try {
      let inputData = {
        type: "Fancy",
        dealerId: id,
      };
      await CatalogDiamondDataService.GetDealersForDiamondSearch(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          handleGetCertificatesForDiamondCatalogList();
          if (message === "Success") {
            if (responseData) {
              setDealersForDiamondCatalogList(responseData);
            } else {
              setDealersForDiamondCatalogList([]);
            }
          } else {
            setDealersForDiamondCatalogList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetDynamicData = async (id) => {
    try {
      let inputData = {
        dealerId: id.toString(),
      };
      await catalogDiamondService
        .GetDynamicData(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setCurrencySign(responseData?.currencySign || "$");
            setCurrencySymbol(responseData?.currencySymbol || "USD");
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetCertificatesForDiamondCatalogList = async () => {
    try {
      let inputData = {
        type: "",
      };
      await CatalogDiamondDataService.GetCertificatesForDiamondCatalogList(
        inputData
      )
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          handleGetAllFancyDropDownList();
          if (message === "Success") {
            if (responseData) {
              setCertificatesForDiamondCatalogList(responseData);
            } else {
              setCertificatesForDiamondCatalogList([]);
            }
          } else {
            setCertificatesForDiamondCatalogList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetOverToneForDiamondCatalogList = async () => {
    try {
      let inputData = {
        type: "",
      };
      await CatalogDiamondDataService.GetOverToneForDiamondCatalogList(
        inputData
      )
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          handleGetLocationsForDiamondCatalogList();
          if (message === "Success") {
            if (responseData) {
              setOverToneForDiamondCatalogList(responseData);
            } else {
              setOverToneForDiamondCatalogList([]);
            }
          } else {
            setOverToneForDiamondCatalogList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetAllFancyDropDownList = async () => {
    try {
      await CatalogDiamondDataService.GetAllFancyDropDownList()
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;

          var fancyIntensity = response.data.responseData.diamondIntensity;
          var diamondPolish = response.data.responseData.diamondPolish;
          var diamondSymmetry = response.data.responseData.diamondSymmetry;
          var diamondCutGrade = response.data.responseData.diamondCutGrade;
          var clarity = response.data.responseData.clarity;
          var diamondFluorescenceColor =
            response.data.responseData.diamondFluorescenceColor;
          handleGetPermissionsForDiamondCatalogList();
          if (message === "Success") {
            if (responseData) {
              setFancyIntensityList(fancyIntensity);
              setDiamondPolishList(diamondPolish);
              setDiamondSymmetryList(diamondSymmetry);
              setDiamondCutGradeList(diamondCutGrade);
              setClarityList(clarity);
              setDiamondFluorescenceColorList(diamondFluorescenceColor);
            } else {
              setFancyIntensityList([]);
              setDiamondPolishList([]);
            }
          } else {
            setFancyIntensityList([]);
            setDiamondPolishList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const applyFilters = () => {
    setHideShowFilter(true);
    handleGetFancyDiamondList(
      loginDetials.responseData.dealerId,
      1,
      15,
      sortColumnName,
      sortType,
      false,
      searchText
    );
    setDisableBtn(true);
  };

  //Initial Watch Data

  const resetFilters = () => {
    setState(initialViewMyColorData);
    setViewMyColorData(initialViewMyColorData);
    setCaratSlideValue([ViewMyColorData.minCarat, ViewMyColorData.maxCarat]);
    setOverallPriceValue([
      ViewMyColorData.minOverallPrice,
      ViewMyColorData.maxOverallPrice,
    ]);
    setPricePerCaratValue([
      ViewMyColorData.minPriceperCaretRange,
      ViewMyColorData.maxPriceperCaretRange,
    ]);
    setLRatioMeasurementsValue([
      ViewMyColorData.minLWRatioMeasurements,
      ViewMyColorData.maxLWRatioMeasurements,
    ]);
    setSearchText("");
    setDisableBtn(false);
    handleGetFancyDiamondList(
      dealerId,
      1,
      15,
      sortColumnName,
      sortType,
      "reset",
      ""
    );
  };

  const onShapeClick = (shape) => {
    setDisableBtn(false);

    if (shape === "All") {
      ViewMyColorData.ShapeIsSelected.All =
        !ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Round =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Radiant =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Princess =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Pear =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Oval =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Marquise =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Heart =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Emerald =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Cushion =
        ViewMyColorData.ShapeIsSelected.All;
      ViewMyColorData.ShapeIsSelected.Asscher =
        ViewMyColorData.ShapeIsSelected.All;
    } else {
      ViewMyColorData.ShapeIsSelected.All = false;
      ViewMyColorData.ShapeIsSelected[shape] =
        !ViewMyColorData.ShapeIsSelected[shape];
    }
    setViewMyColorData((prevState) => ({
      ...prevState,
      ...ViewMyColorData,
    }));
  };

  const onColorClick = (color) => {
    setDisableBtn(false);

    if (color === "All") {
      ViewMyColorData.colorIsSelected.All =
        !ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Blue =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Pink =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Yellow =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Brown =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Green =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Gray =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Black =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Red = ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Purple =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Chameleon =
        ViewMyColorData.colorIsSelected.All;
      ViewMyColorData.colorIsSelected.Violet =
        ViewMyColorData.colorIsSelected.All;
    } else {
      ViewMyColorData.colorIsSelected.All = false;
      ViewMyColorData.colorIsSelected[color] =
        !ViewMyColorData.colorIsSelected[color];
    }

    setViewMyColorData((prevState) => ({
      ...prevState,
      ...ViewMyColorData,
    }));
  };

  var shapesObj = ViewMyColorData.ShapeIsSelected;
  var shapesKeys = Object.keys(shapesObj);
  var filteredShape = shapesKeys.filter(function (key) {
    return shapesObj[key];
  });
  var shapesData = filteredShape + ",";

  var colorObj = ViewMyColorData.colorIsSelected;
  var colorKeys = Object.keys(colorObj);
  var filteredColor = colorKeys.filter(function (key) {
    return colorObj[key];
  });
  var colorData = filteredColor + ",";

  /*Converting into String Format ends*/

  const onKeyPressEvent = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[.0-9]").test(keyValue)) event.preventDefault();
    return;
  };

  const handleCertificateOpen = (item) => {
    if (item.certlink && item.certlink.trim() !== "") {
      window.open(
        item.certlink,
        "CERTVIEW",
        "scrollbars=yes,resizable=no,width=650,height=630"
      );
    } else {
      showCertInfoModal();
      setRequestInfoDetails({
        intDiamondId: item.intDiamondId,
        dealerID: item.dealerID,
      });
    }
  };

  const showCertInfoModal = () => {
    setRequestMoreCertModal(true);
  };
  const closeCertInfoModal = () => {
    setRequestMoreCertModal(false);
    setcertInfoData(initialCertInfoData);
    setcertInfoDataValidation(initialCertInfoValidation);
  };

  const handleCertInfoChange = (e, name, type) => {
    setcertInfoData({
      ...certInfoData,
      [name]: e.target.value,
    });
    if (name == "name") {
      setcertInfoDataValidation((prevdata) => ({
        ...prevdata,
        nameVal: "",
      }));
    }
    if (name == "email") {
      setcertInfoDataValidation((prevdata) => ({
        ...prevdata,
        emailVal: "",
      }));
    }
    if (name == "phoneNumber") {
      setcertInfoDataValidation((prevdata) => ({
        ...prevdata,
        phoneNumberVal: "",
      }));
    }
  };

  const handleSubmitRequestCert = () => {
    handleSaveRequestCertificate();
    setcertInfoData(initialCertInfoData);
  };

  const handleRequestCertificateValidation = () => {
    const { name, email, phoneNumber } = certInfoData;
    const certInfoValidationObj = {
      nameVal: "",
      emailVal: "",
      phoneNumberVal: "",
    };
    let isValid = true;

    if (!name) {
      isValid = false;
      certInfoValidationObj.nameVal = t("First Name is Compulsory");
    }

    let validRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!email) {
      isValid = false;
      certInfoValidationObj.emailVal = t("Email address is compulsory");
    } else if (!email.match(validRegex)) {
      isValid = false;
      certInfoValidationObj.emailVal = t("Email address is invalid");
    } else {
      certInfoValidationObj.emailVal = "";
    }

    if (!phoneNumber) {
      isValid = false;
      certInfoValidationObj.phoneNumberVal = t("Phone number is compulsory");
    } else if (
      (phoneNumber.length >= 10 && phoneNumber.includes("-")) ||
      (phoneNumber.length >= 10 && phoneNumber.includes(",")) ||
      (phoneNumber.length >= 10 && phoneNumber.includes("+"))
    ) {
      certInfoValidationObj.phoneNumberVal = "";
    } else if (!/^(?!0{10,15})(\+\d{1,3}[-]?)?\d{10,15}$/.test(phoneNumber)) {
      isValid = false;
      certInfoValidationObj.phoneNumberVal = t("Phone number is invalid");
    } else {
      certInfoValidationObj.phoneNumberVal = "";
    }
    if (!isValid) {
      setcertInfoDataValidation(certInfoValidationObj);
    }

    return isValid;
  };

  const handleSaveRequestCertificate = async () => {
    const isValid = handleRequestCertificateValidation();
    if (!isValid) {
      return false;
    }
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        did: requestInfoDetails.intDiamondId,
        name: certInfoData.name,
        email: certInfoData.email,
        phone: certInfoData.phoneNumber,
        comments: certInfoData.comments,
        retailerID: requestInfoDetails.dealerID,
      };

      setRequestMoreCertModalLoading(true);
      await AppsRingBuilderService.RingBuilderRequestCertificate(inputData)
        .then((response) => {
          let message = response.data.message;

          if (message === "Success") {
            NotificationManager.success(
              t(
                "Your request has been sent to GemFind. A representative will be contacting you shortly."
              )
            );
            setcertInfoData(initialCertInfoData);
            setcertInfoDataValidation(initialCertInfoValidation);
            setRequestMoreCertModalLoading(false);
          } else {
            NotificationManager.success(
              t(
                "Your request has been sent to GemFind. A representative will be contacting you shortly."
              )
            );
            setcertInfoData(initialCertInfoData);
            setcertInfoDataValidation(initialCertInfoValidation);
            setRequestMoreCertModalLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setcertInfoData(initialCertInfoData);
          setcertInfoDataValidation(initialCertInfoValidation);
          setRequestMoreCertModalLoading(false);
        });
    } catch (error) {
      console.log(error);
      setcertInfoData(initialCertInfoData);
      setcertInfoDataValidation(initialCertInfoValidation);
      setRequestMoreCertModalLoading(false);
    }
  };

  const handleOpenDetailsModal = (row) => {
    setSelectedRowDetails(row);
    setVisible(true);
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    setTimeout(function() {
      document.querySelectorAll('div').forEach(function(el) { if (el.scrollTop > 0) el.scrollTop = 0; });
      window.scrollTo(0, 0);
    }, 100);
    var type = "";
    var column = "";

    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "ASC";
      column = "tmpColumn Asc";
      setSortColumnName(column);
      setSortType(type);
    }

    handleGetFancyDiamondList(
      dealerId,
      pagination.current,
      pagination.pageSize,
      column,
      type,
      false,
      searchText
    );
  };

  const filterOptionForDropdown = (input, option) => {
    const inputValue = typeof input === "number" ? input.toString() : input;
    let childrenValue = "";

    if (typeof option?.children === "number") {
      childrenValue = option.children.toString();
    } else if (typeof option?.children === "string") {
      childrenValue = option.children.toLowerCase();
    } else if (option?.children?.[1]?.props?.id) {
      childrenValue = option.children[1].props.id.toLowerCase();
    }

    return (
      childrenValue &&
      inputValue &&
      childrenValue.includes(inputValue.toLowerCase())
    );
  };
  const onKeyPressEvent1 = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9.]").test(keyValue)) event.preventDefault();
    return;
  };
  const firstsetOverAllSlideValue = (e, num) => {
    setDisableBtn(false);
    let newArr = [...overallPriceValue];
    var StrValue = e.target.value && e.target.value.replace(currencySign, "");
    var Value = StrValue.replace(/,/g, "");
    if (Value.replace(/,/g, "") > ViewMyColorData.maxOverallPrice) {
      e.preventDefault();
    } else if (Number(num) == 0) {
      if (Value == "") {
        newArr[0] = 0;
        setOverallPriceValue(newArr);
      } else {
        if (newArr[0] == 0) {
          newArr[0] = Value;
          setOverallPriceValue(newArr);
        } else {
          newArr[0] = Value;
          setOverallPriceValue(newArr);
        }
      }
    } else if (Number(num) == 1) {
      if (Value == "") {
        newArr[1] = 0;
        setOverallPriceValue(newArr);
      } else {
        if (newArr[1] == 0) {
          newArr[1] = Value;
          setOverallPriceValue(newArr);
        } else {
          newArr[1] = Value;
          setOverallPriceValue(newArr);
        }
      }
    }
  };
  const firstsetCaratSlideValue = (e, num) => {
    setDisableBtn(false);
    let newArr = [...caratSlideValue];
    let StrValue = e.target.value?.replace("$", "");
    let Value = StrValue.replace(/,/g, "");
    if (
      Number(parseFloat(e.target.value.replace(/,/g, ""))) >
      ViewMyColorData.maxCarat
    ) {
      e.preventDefault();
    } else if (Number(num) == 0) {
      if (e.target.value == "" || e.target.value == ".") {
        newArr[0] = 0;
        setCaratSlideValue(newArr);
      } else {
        if (newArr[0] == 0 && Value.includes(".")) {
          let dottedamount = Value.split(".");
          let amount =
            Number(dottedamount[0]).toLocaleString("en-US") +
            "." +
            dottedamount[1];
          newArr[0] = amount;
          setCaratSlideValue(newArr);
        } else {
          if (newArr[0] == 0) {
            newArr[0] = parseFloat(Value);
            setCaratSlideValue(newArr);
          } else {
            newArr[0] = Value;
            setCaratSlideValue(newArr);
          }
        }
      }
    } else if (Number(num) == 1) {
      if (e.target.value == "" || e.target.value == ".") {
        newArr[1] = 0;
        setCaratSlideValue(newArr);
      } else {
        if (newArr[1] == 0 && Value.includes(".")) {
          let dottedamount = Value.split(".");
          let amount =
            Number(dottedamount[0]).toLocaleString("en-US") +
            "." +
            dottedamount[1];
          newArr[1] = amount;
          setCaratSlideValue(newArr);
        } else {
          if (newArr[1] == 0) {
            newArr[1] = parseFloat(Value);
            setCaratSlideValue(newArr);
          } else {
            newArr[1] = Value;
            setCaratSlideValue(newArr);
          }
        }
      }
    }
  };
  const firstsetPricePerCaratValueSlideValue = (e, num) => {
    setDisableBtn(false);
    let newArr = [...pricePerCaratValue];

    var StrValue = e.target.value && e.target.value.replace(currencySign, "");
    var Value = StrValue.replace(/,/g, "");

    if (
      Number(parseFloat(Value.replace(/,/g, ""))) >
      ViewMyColorData.maxPriceperCaretRange
    ) {
      e.preventDefault();
    } else if (Number(num) == 0) {
      if (Value == "") {
        newArr[0] = 0;
        setPricePerCaratValue(newArr);
      } else {
        if (newArr[0] == 0) {
          newArr[0] = Value;
          setPricePerCaratValue(newArr);
        } else {
          newArr[0] = Value;
          setPricePerCaratValue(newArr);
        }
      }
    } else if (Number(num) == 1) {
      if (Value == "") {
        newArr[1] = 0;
        setPricePerCaratValue(newArr);
      } else {
        if (newArr[1] == 0) {
          newArr[1] = Value;
          setPricePerCaratValue(newArr);
        } else {
          newArr[1] = Value;
          setPricePerCaratValue(newArr);
        }
      }
    }
  };
  const firstsetlWRatioMeasurementsValueSlideValue = (e, num) => {
    setDisableBtn(false);
    let newArr = [...lWRatioMeasurementsValue];

    if (
      Number(parseFloat(e.target.value.replace(/,/g, ""))) >
      ViewMyColorData.maxLWRatioMeasurements
    ) {
      e.preventDefault();
    } else if (Number(num) == 0) {
      if (e.target.value == "") {
        newArr[0] = 0;
        setLRatioMeasurementsValue(newArr);
      } else {
        newArr[0] = e.target.value.replace(/,0/g, "").replace(0, "");
        setLRatioMeasurementsValue(newArr);
      }
    } else if (Number(num) == 1) {
      if (e.target.value == "") {
        newArr[1] = 0;
        setLRatioMeasurementsValue(newArr);
      } else {
        newArr[1] = e.target.value.replace(/,0/g, "").replace(0, "");
        setLRatioMeasurementsValue(newArr);
      }
    }
  };
  function formatMoney(amount) {
    try {
      if (amount?.toString().includes(".")) {
        var dottedamount = amount.split(".");
        var amount =
          Number(dottedamount[0]).toLocaleString("en-US") +
          "." +
          dottedamount[1];
      } else {
        var amount = Number(amount).toLocaleString("en-US");
      }
      return amount;
    } catch (e) {
      console.log(e);
    }
  }

  const showModalFullscreen = (row) => {
    setSelectedRowDetails(row);
    setIsModalVisibleFullscreen(true);
  };
  const handleCancelFullscreen = () => {
    setIsModalVisibleFullscreen(false);
  };
  return (
    <React.Fragment>
      <div className="vdiamond_section">
        <div className="form__fields">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-12">
                <Row className="mb-3 table-info-header">
                  <Col>
                    <h4 className="workarea__heading ">
                      {t("Color Diamond Search")}
                    </h4>
                  </Col>
                  <div className="d-flex-sm-block_search">
                    <Col
                      sm={24}
                      md={16}
                      mb-mobile
                      flex-align-center
                      className="mr-desktop"
                    >
                      <div className="search__bar  mb-mobile ">
                        <Search
                          placeholder={t("Stock #")}
                          allowClear
                          value={searchText ? searchText : ""}
                          onChange={(e) => setSearchText(e.target.value)}
                          onSearch={(value) => {
                            const trimmedValue = value.trim();
                            setSearchText(value);
                            setPageNo(1);
                            handleGetFancyDiamondList(
                              dealerId,
                              1,
                              pageSize,
                              sortColumnName,
                              sortType,
                              false,
                              trimmedValue
                            );
                          }}
                        />
                      </div>
                    </Col>
                    <Col className="flex-none">
                      <button
                        className="primary-btn"
                        onClick={handleHideShowFilter}
                      >
                        <img src={Filter_icon} alt="" width="14px" />
                        {hideShowFilter ? (
                          <span>
                            {t("Filter")} <i className="fa fa-angle-down"></i>
                          </span>
                        ) : (
                          <span>
                            {t("Filter")} <i className="fa fa-angle-up"></i>
                          </span>
                        )}
                      </button>
                    </Col>
                  </div>
                </Row>
              </div>
              <div className="col-md-12 relative">
                <div className="filter_section">
                  <div
                    className={
                      hideShowFilter
                        ? "form__fields filter_inpsection hide"
                        : "form__fields filter_inpsection"
                    }
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <div className="input__block">
                            <label> {t("Colors")} </label>
                            <div className="imgselct__div">
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Blue
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Blue")}
                              >
                                <img src={Blue} alt="" />
                                <span> {t("Blue")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Pink
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Pink")}
                              >
                                <img src={Pink} alt="" />
                                <span> {t("Pink")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Yellow
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Yellow")}
                              >
                                <img src={Yellow} alt="" />
                                <span> {t("Yellow")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Brown
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Brown")}
                              >
                                <img src={Brown} alt="" />
                                <span> {t("Brown")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Green
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Green")}
                              >
                                <img src={Green} alt="" />
                                <span> {t("Green")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Gray
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Gray")}
                              >
                                <img src={Gray} alt="" />
                                <span> {t("Gray")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Black
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Black")}
                              >
                                <img src={Black} alt="" />
                                <span> {t("Black")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Red
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Red")}
                              >
                                <img src={Red} alt="" />
                                <span> {t("Red")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Purple
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Purple")}
                              >
                                <img src={Purple} alt="" />
                                <span> {t("Purple")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Chameleon
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Chameleon")}
                              >
                                <img src={Chameleon} alt="" />
                                <span> {t("Chameleon")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.Violet
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onColorClick("Violet")}
                              >
                                <img src={Violet} alt="" />
                                <span> {"Violet"} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.colorIsSelected.All
                                    ? "selected all__div"
                                    : "all__div"
                                }
                                onClick={() => onColorClick("All")}
                              >
                                <span> {t("All")} </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="input__block">
                            <label> {t("Shapes")} </label>
                            <div className="imgselct__div">
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Round
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Round")}
                              >
                                <img src={Roundimg} alt="" />
                                <span> {t("Round")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Radiant
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Radiant")}
                              >
                                <img src={RadiantImg} alt="" />
                                <span> {t("Radiant")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Princess
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Princess")}
                              >
                                <img src={PrincessImg} alt="" />
                                <span> {t("Princess")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Pear
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Pear")}
                              >
                                <img src={PearImg} alt="" />
                                <span> {t("Pear")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Oval
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Oval")}
                              >
                                <img src={OvalImg} alt="" />
                                <span> {t("Oval")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Marquise
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Marquise")}
                              >
                                <img src={MarquiseImg} alt="" />
                                <span> {t("Marquise")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Heart
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Heart")}
                              >
                                <img src={HeartImg} alt="" />
                                <span> {t("Heart")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Emerald
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Emerald")}
                              >
                                <img src={EmeraldImg} alt="" />
                                <span> {t("Emerald")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Cushion
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Cushion")}
                              >
                                <img src={CushionImg} alt="" />
                                <span> {t("Cushion")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.Asscher
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Asscher")}
                              >
                                <img src={AsscherImg} alt="" />
                                <span> {t("Asscher")} </span>
                              </div>
                              <div
                                className={
                                  ViewMyColorData.ShapeIsSelected.All
                                    ? "selected all__div"
                                    : "all__div"
                                }
                                onClick={() => onShapeClick("All")}
                              >
                                <span> {t("All")} </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="sliderrange__maindiv">
                            <label> {t("Carats")} </label>
                            <div className="col-md-12 mt-3">
                              <Slider
                                range
                                value={caratSlideValue}
                                min={ViewMyColorData.minCarat}
                                max={ViewMyColorData.maxCarat}
                                onChange={(e) => {
                                  setCaratSlideValue(e);
                                  setDisableBtn(false);
                                }}
                              />
                              <div className="rangeSlider__values">
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={caratSlideValue[0].toLocaleString(
                                      "en-US"
                                    )}
                                    onChange={(e) => {
                                      firstsetCaratSlideValue(e, 0);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                                <div>
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={caratSlideValue[1].toLocaleString(
                                      "en-US"
                                    )}
                                    onChange={(e) => {
                                      firstsetCaratSlideValue(e, 1);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="sliderrange__maindiv">
                            <label> {t("Overall Price")} </label>
                            <div className="col-md-12 mt-3">
                              <Slider
                                range
                                value={overallPriceValue}
                                min={ViewMyColorData.minOverallPrice}
                                max={ViewMyColorData.maxOverallPrice}
                                onChange={(e) => {
                                  setOverallPriceValue(e);
                                  setDisableBtn(false);
                                }}
                              />
                              <div className="rangeSlider__values">
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={
                                      currencySign +
                                      formatMoney(overallPriceValue[0])
                                    }
                                    onChange={(e) => {
                                      firstsetOverAllSlideValue(e, 0);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                                <div>
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={
                                      currencySign +
                                      formatMoney(overallPriceValue[1])
                                    }
                                    onChange={(e) => {
                                      firstsetOverAllSlideValue(e, 1);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="sliderrange__maindiv">
                            <label>{t("Cost Per Carat Range")}</label>
                            <div className="col-md-12 mt-3">
                              <Slider
                                range
                                value={pricePerCaratValue}
                                min={ViewMyColorData.minPriceperCaretRange}
                                max={ViewMyColorData.maxPriceperCaretRange}
                                onChange={(e) => {
                                  setPricePerCaratValue(e);
                                  setDisableBtn(false);
                                }}
                              />
                              <div className="rangeSlider__values">
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={
                                      currencySign +
                                      formatMoney(pricePerCaratValue[0])
                                    }
                                    onChange={(e) => {
                                      firstsetPricePerCaratValueSlideValue(
                                        e,
                                        0
                                      );
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                                <div>
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={
                                      currencySign +
                                      formatMoney(pricePerCaratValue[1])
                                    }
                                    onChange={(e) => {
                                      firstsetPricePerCaratValueSlideValue(
                                        e,
                                        1
                                      );
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-6">
                          <div className="input__block">
                            <label> {t("Permission")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              showArrow={true}
                              placeholder={t("Any")}
                              name="permission"
                              value={
                                ViewMyColorData.permission
                                  ? ViewMyColorData.permission
                                  : null
                              }
                              defaultvalue=""
                              optionFilterProp="children"
                              // onChange={onChange}
                              onChange={(e) =>
                                handleOnChange(e, "select", "permission")
                              }
                            >
                              {permissionsForDiamondCatalogList.map((item) => {
                                return (
                                  <React.Fragment>
                                    <Option value={item.value}>
                                      {item.text}
                                    </Option>
                                  </React.Fragment>
                                );
                              })}
                            </Select>
                          </div>
                        </div>

                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Clarity")}</label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                placeholder={t("Any")}
                                allowClear
                                name="clarityFrom"
                                value={ViewMyColorData.clarityFrom || "Any"}
                                onChange={(e) =>
                                  handleOnChange(e, "select", "clarityFrom")
                                }
                              >
                                <Option key="clarity-from-any" value="Any">
                                  {t("Any")}
                                </Option>
                                {diamondClarityList.map((item, index) => (
                                  <Option
                                    key={`clarity-from-${index}`}
                                    value={item.claritydetails}
                                  >
                                    {item.claritydetails}
                                  </Option>
                                ))}
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                placeholder={t("Any")}
                                allowClear
                                name="clarityTo"
                                value={ViewMyColorData.clarityTo || "Any"}
                                onChange={(e) =>
                                  handleOnChange(e, "select", "clarityTo")
                                }
                              >
                                <Option key="clarity-to-any" value="Any">
                                  {t("Any")}
                                </Option>
                                {diamondClarityList.map((item, index) => (
                                  <Option
                                    key={`clarity-to-${index}`}
                                    value={item.claritydetails}
                                  >
                                    {item.claritydetails}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Polish")}</label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="polishFrom"
                                value={ViewMyColorData.polishFrom || null}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "polishFrom")
                                }
                              >
                                <Option>{t("Any")}</Option>
                                {diamondPolishList.map((item) => (
                                  <Option
                                    key={item.polishID}
                                    value={item.polishID}
                                  >
                                    {t(item.polishValue)}
                                  </Option>
                                ))}
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="polishTo"
                                value={ViewMyColorData.polishTo || null}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "polishTo")
                                }
                              >
                                <Option>{t("Any")}</Option>
                                {diamondPolishList.map((item) => (
                                  <Option
                                    key={item.polishID}
                                    value={item.polishID}
                                  >
                                    {t(item.polishValue)}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Symmetry")}</label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="symmetryFrom"
                                value={ViewMyColorData.symmetryFrom || null}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "symmetryFrom")
                                }
                              >
                                <Option>{t("Any")}</Option>
                                {diamondSymmetryList.map((item) => (
                                  <Option
                                    key={item.symmetryID}
                                    value={item.symmetryID}
                                  >
                                    {t(item.symmetryValue)}
                                  </Option>
                                ))}
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="symmetryTo"
                                value={ViewMyColorData.symmetryTo || null}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "symmetryTo")
                                }
                              >
                                <Option>{t("Any")}</Option>
                                {diamondSymmetryList.map((item) => (
                                  <Option
                                    key={item.symmetryID}
                                    value={item.symmetryID}
                                  >
                                    {t(item.symmetryValue)}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Cut")}</label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="cutFrom"
                                value={ViewMyColorData.cutFrom || null}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "cutFrom")
                                }
                              >
                                <Option>{t("Any")}</Option>
                                {diamondCutGradeList.map((item) => (
                                  <Option
                                    key={item.cutGradeId}
                                    value={item.cutGradeId}
                                  >
                                    {t(item.cutGradeValue)}
                                  </Option>
                                ))}
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="cutTo"
                                value={ViewMyColorData.cutTo || null}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "cutTo")
                                }
                              >
                                <Option>{t("Any")}</Option>
                                {diamondCutGradeList.map((item) => (
                                  <Option
                                    key={item.cutGradeId}
                                    value={item.cutGradeId}
                                  >
                                    {t(item.cutGradeValue)}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">
                              {t("Fluorescence Intensity")}
                            </label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="fluorescenceIntensityFrom"
                                value={
                                  ViewMyColorData.fluorescenceIntensityFrom ||
                                  null
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "fluorescenceIntensityFrom"
                                  )
                                }
                              >
                                <Option value="0">{t("Any")}</Option>
                                <Option value="1">{t("None")}</Option>
                                <Option value="2">{t("Very Slight")}</Option>
                                <Option value="3">{t("Slight")}</Option>
                                <Option value="4">{t("Faint")}</Option>
                                <Option value="5">{t("Medium")}</Option>
                                <Option value="6">{t("Strong")}</Option>
                                <Option value="7">{t("Very Strong")}</Option>
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="fluorescenceIntensityTo"
                                value={
                                  ViewMyColorData.fluorescenceIntensityTo ||
                                  null
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "fluorescenceIntensityTo"
                                  )
                                }
                              >
                                <Option value="0">{t("Any")}</Option>
                                <Option value="1">{t("None")}</Option>
                                <Option value="2">{t("Very Slight")}</Option>
                                <Option value="3">{t("Slight")}</Option>
                                <Option value="4">{t("Faint")}</Option>
                                <Option value="5">{t("Medium")}</Option>
                                <Option value="6">{t("Strong")}</Option>
                                <Option value="7">{t("Very Strong")}</Option>
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-6">
                          <div className="input__block">
                            <label> {t("Location")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              placeholder={t("Select Location")}
                              name="location"
                              optionFilterProp="children"
                              value={
                                ViewMyColorData.location
                                  ? ViewMyColorData.location
                                  : null
                              }
                              onChange={(e) =>
                                handleOnChange(e, "select", "location")
                              }
                            >
                              <Option value="0"> {t("Any")} </Option>
                              {locationsForDiamondCatalogList.map((item) => {
                                return (
                                  <React.Fragment>
                                    <Option
                                      value={item.name}
                                      key={item.countryID}
                                    >
                                      {item.name}
                                    </Option>
                                  </React.Fragment>
                                );
                              })}
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-6">
                          <div className="input__block">
                            <label> {t("Certificates")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              showArrow={true}
                              mode="multiple"
                              placeholder={t("Select Certificate")}
                              name="certificates"
                              value={
                                ViewMyColorData.certificates
                                  ? ViewMyColorData.certificates
                                  : []
                              }
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(e, "select", "certificates")
                              }
                            >
                              {/* <Option value="0">{t("Search all")}</Option> */}
                              {certificatesForDiamondCatalogList.map((item, i) => {
                                return (
                                  <Option value={item.certificateValue}>
                                    {item.certificateValue}
                                  </Option>
                                );
                              })}
                              {/* {certificatesForDiamondCatalogList.map(
                                    (item) => {
                                      return (
                                        <React.Fragment>
                                          <Option
                                            value={item.certificateValue}
                                            key={item.certificateValue}
                                          >
                                            {item.certificateValue}
                                          </Option>
                                        </React.Fragment>
                                      );
                                    }
                                  )} */}
                              {/* <Option value="GIA">GIA</Option>
                              <Option value="AGS">AGS</Option>
                              <Option value="GCAL">GCAL</Option>
                              <Option value="IGI">IGI</Option>
                              <Option value="EGLUSA">EGL USA</Option>
                              <Option value="FM">FM</Option>
                              <Option value="HRD">HRD</Option>
                              <Option value="EGLINT">EGL INT</Option>
                              <Option value="OTHER">Other</Option> */}

                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-6">
                          <div className="input__block">
                            <label> {t("Eye Clean")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              placeholder={t("Select Eye Clean Inclusion")}
                              name="eyeClean"
                              mode="multiple"
                              value={
                                ViewMyColorData.eyeClean
                                  ? ViewMyColorData.eyeClean
                                  : []
                              }
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(e, "select", "eyeClean")
                              }
                            >
                              <Option value="Any">{t("Any")} </Option>
                              <Option value={t("Yes")}>{t("Yes")} </Option>
                              <Option value="BorderLine">
                                {t("Borderline")}{" "}
                              </Option>
                              <Option value="No"> {t("No")} </Option>
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-6">
                          <div className="input__block">
                            <label> {t("Overtone 1")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              mode="multiple"
                              placeholder={t("Select Overtone 1")}
                              value={
                                ViewMyColorData.overtone1
                                  ? ViewMyColorData.overtone1
                                  : []
                              }
                              name="overtone1"
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(e, "select", "overtone1")
                              }
                            >
                              <Option value=""> {t("Any")} </Option>
                              {overToneForDiamondCatalogList &&
                                overToneForDiamondCatalogList.map((item) => {
                                  return (
                                    <React.Fragment>
                                      <Option
                                        value={item.overtoneValue}
                                        key={item.overtoneID}
                                      >
                                        {item.overtoneValue}
                                      </Option>
                                    </React.Fragment>
                                  );
                                })}
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-6">
                          <div className="input__block">
                            <label> {t("Overtone 2")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              placeholder={t("Select Overtone 2")}
                              name="overtone2"
                              mode="multiple"
                              value={
                                ViewMyColorData.overtone2
                                  ? ViewMyColorData.overtone2
                                  : []
                              }
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(e, "select", "overtone2")
                              }
                            >
                              <Option value=""> {t("Any")} </Option>
                              {overToneForDiamondCatalogList.map((item) => {
                                return (
                                  <React.Fragment>
                                    <Option
                                      value={item.overtoneValue}
                                      key={item.overtoneID}
                                    >
                                      {item.overtoneValue}
                                    </Option>
                                  </React.Fragment>
                                );
                              })}
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label> {t("Fancy Intensity")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              showArrow={true}
                              placeholder={t("Any")}
                              name="fancyIntensity"
                              value={
                                ViewMyColorData.fancyIntensity
                                  ? ViewMyColorData.fancyIntensity
                                  : null
                              }
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(e, "select", "fancyIntensity")
                              }
                            >
                              <Option value="0"> {t("Any")} </Option>
                              {fancyIntensityList.map((item) => {
                                return (
                                  <React.Fragment>
                                    <Option
                                      value={item.intensityId}
                                      key={item.intensityId}
                                    >
                                      {t(item.intensityValue)}
                                    </Option>
                                  </React.Fragment>
                                );
                              })}
                            </Select>
                          </div>
                        </div>

                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label>{t("Fluorescence Color")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              placeholder={t("Select Fluorescence Color")}
                              name="fluorescenceColor"
                              mode="multiple"
                              value={
                                ViewMyColorData.fluorescenceColor
                                  ? ViewMyColorData.fluorescenceColor
                                  : []
                              }
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(e, "select", "fluorescenceColor")
                              }
                            >
                              <Option> {t("Any")} </Option>
                              {diamondFluorescenceColorList.map((item) => {
                                return (
                                  <React.Fragment>
                                    <Option
                                      value={item.fluorescenceValue}
                                      key={item.fluorescenceValue}
                                    >
                                      {t(item.fluorescenceValue)  }
                                    </Option>
                                  </React.Fragment>
                                );
                              })}
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="input__block">
                            <label> {t("Dealers")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              showArrow={true}
                              mode="multiple"
                              placeholder={t("Select Dealers")}
                              name="dealers"
                              value={
                                ViewMyColorData.dealers
                                  ? ViewMyColorData.dealers
                                  : null
                              }
                              optionFilterProp="children"
                              onChange={(e) =>
                                handleOnChange(e, "select", "dealers")
                              }
                            >
                              <Option value="0">{t("Search all")} </Option>
                              {dealersForDiamondCatalogList.map((item) => {
                                return (
                                  <React.Fragment>
                                    <Option
                                      value={item.dealerID}
                                      key={item.dealerID}
                                    >
                                      {item.dealerCompany}
                                    </Option>
                                  </React.Fragment>
                                );
                              })}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 mt-2">
                      {showMoreFilter && (
                        <div className="row">
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Length(mm)")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="lengthFrom"
                                  value={ViewMyColorData.lengthFrom || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "lengthFrom")
                                  }
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="lengthTo"
                                  value={ViewMyColorData.lengthTo || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "lengthTo")
                                  }
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Width(mm)")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="widthFrom"
                                  value={ViewMyColorData.widthFrom || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "widthFrom")
                                  }
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="widthTo"
                                  value={ViewMyColorData.widthTo || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "widthTo")
                                  }
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Height(mm)")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="heightFrom"
                                  value={ViewMyColorData.heightFrom || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "heightFrom")
                                  }
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="heightTo"
                                  value={ViewMyColorData.heightTo || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "heightTo")
                                  }
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div className="sliderrange__maindiv">
                              <label>{t("L/W Ratio Measurements")} </label>
                              <div className="col-md-12 mt-3">
                                <Slider
                                  range
                                  value={lWRatioMeasurementsValue}
                                  min={ViewMyColorData.minLWRatioMeasurements}
                                  max={ViewMyColorData.maxLWRatioMeasurements}
                                  onChange={(e) => {
                                    setLRatioMeasurementsValue(e);
                                    setDisableBtn(false);
                                  }}
                                />
                                <div className="rangeSlider__values">
                                  <div className="input__block">
                                    <input
                                      type="text"
                                      value={lWRatioMeasurementsValue[0].toLocaleString(
                                        "en-US"
                                      )}
                                      onChange={(e) => {
                                        firstsetlWRatioMeasurementsValueSlideValue(
                                          e,
                                          0
                                        );
                                      }}
                                      onKeyPress={onKeyPressEvent1}
                                    />
                                  </div>
                                  <div>
                                    <img
                                      src={space__icon}
                                      className="img-fluid space__icon"
                                    />
                                  </div>
                                  <div className="input__block">
                                    <input
                                      type="text"
                                      value={lWRatioMeasurementsValue[1].toLocaleString(
                                        "en-US"
                                      )}
                                      onChange={(e) => {
                                        firstsetlWRatioMeasurementsValueSlideValue(
                                          e,
                                          1
                                        );
                                      }}
                                      onKeyPress={onKeyPressEvent1}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label> {t("Shade")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                mode="multiple"
                                name="shade"
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "shade")
                                }
                                value={
                                  ViewMyColorData.shade
                                    ? ViewMyColorData.shade
                                    : []
                                }
                              >
                                <Option value="Any">{t("Any")} </Option>
                                <Option value="None">{t("None")} </Option>
                                <Option value="No Yellow">
                                  {t("No Yellow")}{" "}
                                </Option>
                                <Option value="No Green">
                                  {t("No Green")}{" "}
                                </Option>
                                <Option value="No Grey">{t("No Grey")} </Option>
                                <Option value="No Black">
                                  {t("No Black")}{" "}
                                </Option>
                                <Option value="No Pink">{t("No Pink")} </Option>
                                <Option value="No Blue">{t("No Blue")} </Option>
                                <Option value="No Brown">
                                  {t("No Brown")}{" "}
                                </Option>
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label>{t("Central Inclusion Range")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="centralInclusionRange"
                                mode="multiple"
                                value={
                                  ViewMyColorData.centralInclusionRange
                                    ? ViewMyColorData.centralInclusionRange
                                    : []
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "centralInclusionRange"
                                  )
                                }
                              >
                                <Option value="Any">{t("Any")} </Option>
                                <Option value="None">{t("None")} </Option>
                                <Option value="Light">{t("Light")} </Option>
                                <Option value="Medium">{t("Medium")} </Option>
                                <Option value="Heavy">{t("Heavy")} </Option>
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label>{t("Black Inclusion Range")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="blackInclusionRange"
                                mode="multiple"
                                value={
                                  ViewMyColorData.blackInclusionRange
                                    ? ViewMyColorData.blackInclusionRange
                                    : []
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "blackInclusionRange"
                                  )
                                }
                              >
                                <Option value="Any">{t("Any")} </Option>
                                <Option value="None">{t("None")} </Option>
                                <Option value="Light">{t("Light")} </Option>
                                <Option value="Medium">{t("Medium")} </Option>
                                <Option value="Heavy">{t("Heavy")} </Option>
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label>{t("Milky Inclusion Range")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="milkyInclusionRange"
                                mode="multiple"
                                value={
                                  ViewMyColorData.milkyInclusionRange
                                    ? ViewMyColorData.milkyInclusionRange
                                    : []
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(
                                    e,
                                    "select",
                                    "milkyInclusionRange"
                                  )
                                }
                              >
                                <Option value="Any">{t("Any")} </Option>
                                <Option value="None">{t("None")} </Option>
                                <Option value="Light">{t("Light")} </Option>
                                <Option value="Medium">{t("Medium")} </Option>
                                <Option value="Heavy">{t("Heavy")} </Option>
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Girdle Range")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="girdleRangeFrom"
                                  value={
                                    ViewMyColorData.girdleRangeFrom || null
                                  }
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(
                                      e,
                                      "select",
                                      "girdleRangeFrom"
                                    )
                                  }
                                >
                                  <Option value="0">{t("Any")}</Option>
                                  <Option value="1">
                                    {t("Extremely Thin")}
                                  </Option>
                                  <Option value="2">{t("Very Thin")}</Option>
                                  <Option value="3">{t("Thin")}</Option>
                                  <Option value="4">
                                    {t("Slightly Thin")}
                                  </Option>
                                  <Option value="5">{t("Medium")}</Option>
                                  <Option value="6">
                                    {t("Slightly Thick")}
                                  </Option>
                                  <Option value="7">{t("Thick")}</Option>
                                  <Option value="15">{t("Very Thick")}</Option>
                                  <Option value="9">
                                    {t("Extremely Thick")}
                                  </Option>
                                  <Option value="10">{t("Extra Thin")}</Option>
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="girdleRangeTo"
                                  value={ViewMyColorData.girdleRangeTo || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "girdleRangeTo")
                                  }
                                >
                                  <Option value="0">{t("Any")}</Option>
                                  <Option value="1">
                                    {t("Extremely Thin")}
                                  </Option>
                                  <Option value="2">{t("Very Thin")}</Option>
                                  <Option value="3">{t("Thin")}</Option>
                                  <Option value="4">
                                    {t("Slightly Thin")}
                                  </Option>
                                  <Option value="5">{t("Medium")}</Option>
                                  <Option value="6">
                                    {t("Slightly Thick")}
                                  </Option>
                                  <Option value="7">{t("Thick")}</Option>
                                  <Option value="15">{t("Very Thick")}</Option>
                                  <Option value="9">
                                    {t("Extremely Thick")}
                                  </Option>
                                  <Option value="10">{t("Extra Thin")}</Option>
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Crown Angle % Range")}
                              </label>
                              <div className="filter-range-pair percentage_filter">
                                <div className="input__block col-lg-5">
                                  <input
                                    type="text"
                                    onKeyPress={onKeyPressEvent}
                                    min="0"
                                    max="100"
                                    name="crownAngleRangeFrom"
                                    value={ViewMyColorData.crownAngleRangeFrom}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          3
                                        );
                                        onNumberChange(
                                          e,
                                          "crownAngleRangeFrom"
                                        );
                                      }
                                    }}
                                  />
                                  <span className="ampcent__txt">%</span>
                                </div>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <div className="input__block col-lg-5">
                                  <input
                                    type="text"
                                    onKeyPress={onKeyPressEvent}
                                    name="crownAngleRangeTo"
                                    value={ViewMyColorData.crownAngleRangeTo}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          3
                                        );
                                        onNumberChange(e, "crownAngleRangeTo");
                                      }
                                    }}
                                  />
                                  <span className="ampcent__txt">%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Pavilion Angle % Range")}
                              </label>
                              <div className="filter-range-pair percentage_filter">
                                <div className="input__block col-lg-5">
                                  <input
                                    type="text"
                                    onKeyPress={onKeyPressEvent}
                                    name="pavilionAngleRangeFrom"
                                    value={
                                      ViewMyColorData.pavilionAngleRangeFrom
                                    }
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          3
                                        );
                                        onNumberChange(
                                          e,
                                          "pavilionAngleRangeFrom"
                                        );
                                      }
                                    }}
                                  />
                                  <span className="ampcent__txt">%</span>
                                </div>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <div className="input__block col-lg-5">
                                  <input
                                    type="text"
                                    onKeyPress={onKeyPressEvent}
                                    name="pavilionAngleRangeTo"
                                    value={ViewMyColorData.pavilionAngleRangeTo}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          3
                                        );
                                        onNumberChange(
                                          e,
                                          "pavilionAngleRangeTo"
                                        );
                                      }
                                    }}
                                  />
                                  <span className="ampcent__txt">%</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label> {t("Key to Symbols")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="keytoSymbols"
                                mode="multiple"
                                value={
                                  ViewMyColorData.keytoSymbols
                                    ? ViewMyColorData.keytoSymbols
                                    : []
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "keytoSymbols")
                                }
                              >
                                <Option value="Any">{t("Any")} </Option>
                                <Option value="Bearding">
                                  {t("Bearding")}{" "}
                                </Option>
                                <Option value="Brown Patch of Color">
                                  {t("Brown Patch of Color")}{" "}
                                </Option>
                                <Option value="Bruise">{t("Bruise")} </Option>
                                <Option value="Cavity">{t("Cavity")} </Option>
                                <Option value="Chip">{t("Chip")} </Option>
                                <Option value="Cleavage">
                                  {t("Cleavage")}{" "}
                                </Option>
                                <Option value="Cloud">{t("Cloud")} </Option>
                                <Option value="Crystal Surface">
                                  {t("Crystal Surface")}{" "}
                                </Option>
                                <Option value="Etch Channel">
                                  {t("Etch Channel")}{" "}
                                </Option>
                                <Option value="Extra Facet">
                                  {t("Extra Facet")}{" "}
                                </Option>
                                <Option value="Feather">{t("Feather")} </Option>
                                <Option value="Flux Remnant">
                                  {t("Flux Remnant")}{" "}
                                </Option>
                                <Option value="Indented Natural">
                                  {t("Indented Natural")}{" "}
                                </Option>
                                <Option value="Internal Graining">
                                  {t("Internal Graining")}{" "}
                                </Option>
                                <Option value="Internal Inscription">
                                  {t("Internal Inscription")}{" "}
                                </Option>
                                <Option value="Internal Laser Drilling">
                                  {t("Internal Laser Drilling")}{" "}
                                </Option>
                                <Option value="Knot">{t("Knot")} </Option>
                                <Option value="Laser Drill Hole">
                                  {t("Laser Drill Hole")}{" "}
                                </Option>
                                <Option value="Manufacturing Remnant">
                                  {t("Manufacturing Remnant")}{" "}
                                </Option>
                                <Option value="Minor Details of Polish">
                                  {t("Minor Details of Polish")}{" "}
                                </Option>
                                <Option value="Natural">{t("Natural")} </Option>
                                <Option value="Needly">{t("Needly")} </Option>
                                <Option value="No Inclusion">
                                  {t("No Inclusion")}{" "}
                                </Option>
                                <Option value="Pinpoint">
                                  {t("Pinpoint")}{" "}
                                </Option>
                                <Option value="Reflecting Surface Graining">
                                  {t("Reflecting Surface Graining")}{" "}
                                </Option>
                                <Option value="Surface Graining">
                                  {t("Surface Graining")}{" "}
                                </Option>
                                <Option value="Twinning Wisp">
                                  {t("Twinning Wisp")}{" "}
                                </Option>
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Culet Range")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="culetRangeFrom"
                                  value={ViewMyColorData.culetRangeFrom || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(
                                      e,
                                      "select",
                                      "culetRangeFrom"
                                    )
                                  }
                                >
                                  <Option value="0">{t("Any")}</Option>
                                  <Option value="1">{t("None")}</Option>
                                  <Option value="2">{t("Small")}</Option>
                                  <Option value="3">{t("Very Small")}</Option>
                                  <Option value="4">{t("Medium")}</Option>
                                  <Option value="5">{t("Large")}</Option>
                                  <Option value="6">{t("Very Large")}</Option>
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="culetRangeTo"
                                  value={ViewMyColorData.culetRangeTo || null}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(e, "select", "culetRangeTo")
                                  }
                                >
                                  <Option value="0">{t("Any")}</Option>
                                  <Option value="1">{t("None")}</Option>
                                  <Option value="2">{t("Small")}</Option>
                                  <Option value="3">{t("Very Small")}</Option>
                                  <Option value="4">{t("Medium")}</Option>
                                  <Option value="5">{t("Large")}</Option>
                                  <Option value="6">{t("Very Large")}</Option>
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Culet Condition Range")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="culetConditionRangeFrom"
                                  value={
                                    ViewMyColorData.culetConditionRangeFrom ||
                                    null
                                  }
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(
                                      e,
                                      "select",
                                      "culetConditionRangeFrom"
                                    )
                                  }
                                >
                                  <Option value="0">{t("Any")}</Option>
                                  <Option value="1">{t("None")}</Option>
                                  <Option value="2">{t("Abraded")}</Option>
                                  <Option value="3">{t("Chipped")}</Option>
                                  <Option value="4">{t("Pointed")}</Option>
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  name="culetConditionRangeTo"
                                  value={
                                    ViewMyColorData.culetConditionRangeTo ||
                                    null
                                  }
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    handleOnChange(
                                      e,
                                      "select",
                                      "culetConditionRangeTo"
                                    )
                                  }
                                >
                                  <Option value="0">{t("Any")}</Option>
                                  <Option value="1">{t("None")}</Option>
                                  <Option value="2">{t("Abraded")}</Option>
                                  <Option value="3">{t("Chipped")}</Option>
                                  <Option value="4">{t("Pointed")}</Option>
                                </Select>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label> {t("Treatment")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                name="treatment"
                                mode="multiple"
                                value={
                                  ViewMyColorData.treatment
                                    ? ViewMyColorData.treatment
                                    : []
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "treatment")
                                }
                              >
                                <Option value="Laser Drilled">
                                  {t("Laser Drilled")}{" "}
                                </Option>
                                <Option value="Clarity Enhanced">
                                  {t("Clarity Enhanced")}{" "}
                                </Option>
                                <Option value="Color Enhanced">
                                  {t("Color Enhanced")}{" "}
                                </Option>
                                <Option value="Irradiated">
                                  {t("Irradiated")}{" "}
                                </Option>
                                <Option value="HPHT">{t("HPHT")} </Option>
                                <Option value="Other">{t("Other")} </Option>
                                <Option value="Any">{t("Any")} </Option>
                                <Option value="None">{t("None")} </Option>
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">{t("Depth")}</label>
                              <div className="filter-range-pair percentage_filter">
                                <div className="input__block col-lg-5">
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    onKeyPress={onKeyPressEvent}
                                    name="depthFrom"
                                    value={ViewMyColorData.depthFrom}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        onNumberChange(e, "depthFrom");
                                      }
                                    }}
                                  />
                                  <span className="ampcent__txt">%</span>
                                  {validation.depthFrom && (
                                    <span className="error-color-red">
                                      {validation.depthFrom}
                                    </span>
                                  )}
                                </div>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <div className="input__block col-lg-5">
                                  <input
                                    type="number"
                                    onKeyPress={onKeyPressEvent}
                                    name="depthTo"
                                    value={ViewMyColorData.depthTo}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        onNumberChange(e, "depthTo");
                                      }
                                    }}
                                    min={0}
                                    max={100}
                                  />
                                  <span className="ampcent__txt">%</span>
                                  {validation.depthTo && (
                                    <span className="error-color-red">
                                      {validation.depthTo}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">{t("Table")}</label>
                              <div className="filter-range-pair percentage_filter">
                                <div className="input__block col-lg-5">
                                  <input
                                    type="number"
                                    onKeyPress={onKeyPressEvent}
                                    name="tableFrom"
                                    value={ViewMyColorData.tableFrom}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        onNumberChange(e, "tableFrom");
                                      }
                                    }}
                                    min={0}
                                    max={100}
                                  />
                                  <span className="ampcent__txt">%</span>
                                  {validation.tableFrom && (
                                    <span className="error-color-red">
                                      {validation.tableFrom}
                                    </span>
                                  )}
                                </div>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <div className="input__block col-lg-5">
                                  <input
                                    type="number"
                                    onKeyPress={onKeyPressEvent}
                                    name="tableTo"
                                    value={ViewMyColorData.tableTo}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        onNumberChange(e, "tableTo");
                                      }
                                    }}
                                    min={0}
                                    max={100}
                                  />
                                  <span className="ampcent__txt">%</span>
                                  {validation.tableTo && (
                                    <span className="error-color-red">
                                      {validation.tableTo}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label> {t("Matched Pairs")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                showArrow={true}
                                mode="multiple"
                                placeholder={t("Search All Stones")}
                                name="matchedPairs"
                                value={
                                  ViewMyColorData.matchedPairs
                                    ? ViewMyColorData.matchedPairs
                                    : []
                                }
                                optionFilterProp="children"
                                onChange={(e) =>
                                  handleOnChange(e, "select", "matchedPairs")
                                }
                              >
                                <Option value="0">
                                  {t("Search All Stones")}{" "}
                                </Option>
                                <Option value={t("Yes")}>
                                  {t("Search Single Stone")}{" "}
                                </Option>
                                <Option value="No">
                                  {t("Search Match Pairs")}{" "}
                                </Option>
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-6">
                            <div className="input__block">
                              <label> {t("LW Ratio")} </label>
                              <div className="radio__div">
                                <div className="radio__block mb-0">
                                  <input
                                    type="radio"
                                    id="lwRatioAny"
                                    name="Any"
                                    value={ViewMyColorData.Radio}
                                    checked={
                                      ViewMyColorData.Radio === "Any"
                                        ? true
                                        : false
                                    }
                                    onChange={handleOnChangeRadio}
                                  />
                                  <label for="any">{t("Any")} </label>
                                </div>
                                <div className="radio__block mb-0">
                                  <input
                                    type="radio"
                                    id="lwRatioSquare"
                                    name="Square"
                                    value={ViewMyColorData.Radio}
                                    checked={
                                      ViewMyColorData.Radio === "Square"
                                        ? true
                                        : false
                                    }
                                    onChange={handleOnChangeRadio}
                                  />
                                  <label for="sqr">{t("Square")} </label>
                                </div>
                                <div className="radio__block mb-0">
                                  <input
                                    type="radio"
                                    id="lwRatioRec"
                                    name="Rectangle"
                                    value={ViewMyColorData.Radio}
                                    checked={
                                      ViewMyColorData.Radio === "Rectangle"
                                        ? true
                                        : false
                                    }
                                    onChange={handleOnChangeRadio}
                                  />
                                  <label for="rec">{t("Rectangle")} </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-6">
                            <div className="input__block">
                              <label> {t("Has Video")} </label>
                              <Switch
                                name="hasVideo"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={ViewMyColorData.hasVideo}
                                // onChange={(e) => (e, "select", "visibility")}
                                onChange={(e) =>
                                  handleOnChange(e, "select", "hasVideo")
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-12 filtbtn_div">
                          <button
                            className="primary-btn mr-2"
                            onClick={() => setShowMoreFilter(!showMoreFilter)}
                          >
                            {showMoreFilter == false
                              ? t("More Filters")
                              : t("Less Filters")}
                          </button>
                          <button
                            type="submit"
                            className="primary-btn mr-2"
                            onClick={resetFilters}
                          >
                            {" "}
                            {t("Reset Filters")}
                          </button>

                          <Button
                            className={
                              disableBtn ? "disabled-btn" : "primary-btn"
                            }
                            disabled={disableBtn}
                            onClick={applyFilters}
                          >
                            {t("Apply Filters")}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                {/*there is a search filter in react for table*/}
                <Table
                  bordered={true}
                  className={`vdiamond__table mobile_tbl`}
                  columns={[
                    // {
                    //   title: "",
                    //   dataIndex: "view",
                    //   width: "30px",
                    //   render: (item, row) => {
                    //     return (
                    //       <React.Fragment>
                    //         <div
                    //           className="infoicon__div"
                    //           onClick={() => handleOpenDetailsModal(row)}
                    //         >
                    //           <i className="fa fa-info-circle"></i>
                    //         </div>
                    //       </React.Fragment>
                    //     );
                    //   },
                    // },
                    {
                      title: (
                        <Tooltip title={t("Stock #")}>{t("Stock #")}</Tooltip>
                      ),
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "txtStockNo",
                      responsive: ["lg"],
                      key: "txtStockNo",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      onCell: () => ({
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        },
                      }),
                      // sorter: (a, b) =>
                      //   a.txtStockNo.localeCompare(b.txtStockNo),
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "txtShape",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) => a.txtShape.localeCompare(b.txtShape),
                      key: "txtShape",
                      // sorter: (a, b) => a.dealerId - b.dealerId,

                      render: (item, row) => {
                        return (
                          <div className="shape__img">
                            <div className="shape__icon">
                              <img src={row.imageSmallShape} />
                            </div>
                            {window.innerWidth > 768 && (
                              <span>{row.txtShape}</span>
                            )}
                          </div>
                        );
                      },
                    },
                    {
                      title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "fltCarat",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) =>
                      //   a.txtStockNo.localeCompare(b.txtStockNo),
                      key: "fltCarat",
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "txtFancyColorMainBody",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) => a.txtColor.localeCompare(b.txtColor),
                      key: "txtFancyColorMainBody",
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: (
                        <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>
                      ),
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "txtClarity",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) =>
                      //   a.txtClarity.localeCompare(b.txtClarity),
                      key: "txtClarity",
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: (
                        <Tooltip title={t("Certificate")}>{t("Cert.")}</Tooltip>
                      ),
                      dataIndex: "txtCertificate",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      ellipsis: true,
                      sorter: (a, b) => { },
                      render: (row, item) => {
                        return (
                          <div className="infoicon__div">
                            <span
                              className="linkText"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setSelectedColumnId(item?.dealerInventoryNo);
                                handleCertificateOpen(item);
                              }}
                            >
                              {item.txtCertificate}
                            </span>
                          </div>
                        );
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Fluorescence")}>
                          {t("Fluor.")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "txtFluorescence",
                      sorter: (a, b) => { },
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      render: (item, row) => {
                        //console.log(dealerMemberTypeName)
                        return row.txtFluorescence;
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Polish")}>{t("Polish")}</Tooltip>
                      ),
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "txtPolish",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) => a.txtPolish.localeCompare(b.txtPolish),
                      key: "txtPolish",
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "realPrice",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) => a.realPrice.localeCompare(b.realPrice),
                      key: "realPrice",
                      // sorter: (a, b) => a.dealerId - b.dealerId,

                      ellipsis: true,
                      render: (item, row) => {
                        return (
                          <>
                            {row?.currency ? row?.currency + " " : " "}
                            {row.realPrice
                              ? parseFloat(row.realPrice).toFixed(2).replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              )
                              : ""}
                          </>
                        );
                      },
                    },
                    {
                      title: <Tooltip title={t("Depth")}>{t("Depth")}</Tooltip>,
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "fltDepth",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) => a.fltDepth.localeCompare(b.fltDepth),
                      key: "fltDepth",
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: <Tooltip title={t("Table")}>{t("Table")}</Tooltip>,
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "fltTable",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) => a.fltTable.localeCompare(b.fltTable),
                      key: "fltTable",
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: (
                        <Tooltip title={t("Seller")}>{t("Seller")}</Tooltip>
                      ),
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "dealerCompany",
                      key: "dealerCompany",
                      responsive: ["lg"],
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                      width: 150,
                      render: (row, item) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              width: "100%",
                            }}
                            className="infoicon__div"
                          >
                            <span
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleOk1(item);
                                setSelectedColumnId(item?.dealerInventoryNo);
                              }}
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                width: "100%",
                                cursor: "pointer",
                              }}
                              title={item.dealerCompany}
                            >
                              <i
                                className="fa fa-comments"
                                aria-hidden="true"
                              ></i>{" "}
                              {item.dealerCompany}
                            </span>
                          </div>
                        );
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Location")}>{t("Location")}</Tooltip>
                      ),
                      ellipsis: true,
                      // ...getColumnSearchProps("dealerId"),
                      dataIndex: "location",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      // sorter: (a, b) => a.location.localeCompare(b.location),
                      key: "location",
                      // sorter: (a, b) => a.dealerId - b.dealerId,
                    },
                    {
                      title: <Tooltip title={t("Video")}>{t("Video")}</Tooltip>,
                      ellipsis: true,
                      width: "40px",
                      responsive: ["lg"],

                      onCell: (row) => {
                        if (row.videoFileName) {
                          return {
                            onClick: (e) => {
                              e.stopPropagation();
                            },
                          };
                        }
                        return {};
                      },

                      render: (item, row) => {
                        return row.videoFileName ? (
                          <div
                            style={{ padding: "5px", margin: "-4px" }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setSelectedColumnId(row?.dealerInventoryNo);
                              handleOpenVideoImageModal(row, true);
                            }}
                          >
                            <i
                              className="fa fa-video-camera"
                              style={{ color: "#0078d7", cursor: "pointer" }}
                            ></i>
                          </div>
                        ) : null;

                        // Uncomment and extend if you plan to handle images later
                        /*
                        : row.imageFileName ? (
                          <div
                            style={{ padding: "5px", margin: "-4px" }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleOpenVideoImageModal(row, false);
                            }}
                          >
                            <i
                              className="fa fa-image linkText"
                              style={{ color: "#0078d7", cursor: "pointer" }}
                            ></i>
                          </div>
                        ) : null;
                        */
                      },
                    },
                  ]}
                  dataSource={fancyDiamondList}
                  loading={gridLoading}
                  pagination={{
                    size: "small",
                    total: totalCount,
                    current: pageNo,
                    pageSize: pageSize,
                    pageSizeOptions: [10, 15, 20, 50, 100],
                    responsive: true,
                    showSizeChanger: true,
                    showTotal: (total, range) => (
                      <div className="pagination-total">{`${range[0]}-${range[1]} of ${total} diamonds`}</div>
                    ),
                  }}
                  onChange={(pagination, filters, sorters) => {
                    document
                      .getElementsByClassName("content__area")[0]
                      .scroll(0, 0);
                    handleTableASCDES(pagination, filters, sorters);
                  }}
                  onRow={(record, recordIndex) => ({
                    onClick: (event) => {
                      setSelectedColumnId(record?.dealerInventoryNo);
                      handleOpenDetailsModal(record);
                    },
                  })}
                  rowClassName={(record) =>
                    record.dealerInventoryNo == selectedColumnId
                      ? "row-active"
                      : ""
                  }
                />
              </div>
              <div className="col-lg-12">
                <Modal
                  title={t("View Details")}
                  className="modalvdiamond__section"
                  centered
                  visible={visible}
                  onOk={() => setVisible(false)}
                  onCancel={() => setVisible(false)}
                  width={1200}
                  footer={[
                    <Button key="back" onClick={handleCancel}>
                      {t("Cancel")}
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleOk}>
                      {t("Contact Dealer")}
                    </Button>,
                  ]}
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          <div className="row">
                            <div className="col-lg-2 mt-4 text-center">
                              <div className="viewdtls__left">
                                <img
                                  src={selectedRowDetails.imageBigShape}
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              <div>
                                {selectedRowDetails.videoFileName && (
                                  <i
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setSelectedColumnId(
                                        selectedRowDetails?.dealerInventoryNo
                                      );
                                      handleOpenVideoImageModal(
                                        selectedRowDetails,
                                        true
                                      );
                                    }}
                                    className="fa fa-video-camera"
                                    style={{
                                      color: "#0078d7",
                                      cursor: "pointer",
                                    }}
                                  ></i>
                                )}
                                {selectedRowDetails?.imageBigShape ? (
                                  <i
                                    class="fa fa-arrows-alt mt-6 linkText ml-2"
                                    aria-hidden="true"
                                    onClick={() => {
                                      showModalFullscreen(selectedRowDetails);
                                    }}
                                  ></i>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-lg-10 mt-4">
                              <div
                                className="info__div"
                                style={{
                                  display: "flex",
                                  gap: "16px", // spacing between columns
                                }}
                              >
                                <div
                                  style={{
                                    borderRight: "1px solid #ccc",
                                    paddingRight: "16px",
                                    flex: 1,
                                  }}
                                >
                                  <p>
                                    <span className="head__txt">
                                      {t("GemFind")}#:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.intDiamondId}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {" "}
                                      {t("Cost Price")}{t(" (" + currencySymbol + ")")}
                                      :
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.currency}{" "}
                                      {selectedRowDetails.realPrice
                                        ? parseFloat(
                                          selectedRowDetails.realPrice
                                        ).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,",")
                                        : ""}
                                    </span>
                                  </p>
                                  {currencySign !== "$" && (
                                    <p>
                                      <span className="head__txt">
                                        {t("Cost Price")}{t("(USD)")}:
                                      </span>{" "}
                                      <span className="val__txt">
                                        {"$" +
                                          " " +
                                          (selectedRowDetails.fltPriceUsd
                                            ? parseFloat(
                                              selectedRowDetails.fltPriceUsd
                                            ).toFixed(2)
                                            : "")}
                                      </span>
                                    </p>
                                  )}
                                  <p>
                                    <span className="head__txt">
                                      {t("Color")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtFancyColorMainBody}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Depth")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltDepth + "%"}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Carat Weight")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltCarat}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Symmetry")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtSymmetry}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Fluorescence")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtFluorescence}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Measurements")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtMeasurements}
                                    </span>
                                  </p>
                                </div>

                                <div
                                  style={{
                                    borderRight: "1px solid #ccc",
                                    paddingRight: "16px",
                                    flex: 1,
                                  }}
                                >
                                  <p>
                                    <span className="head__txt">
                                      {t("Treatment")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.treatment}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Shape")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtShape}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Clarity")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtClarity}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Table")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltTable + "%"}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Polish")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtPolish}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Crown")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltCrown}
                                    </span>
                                  </p>
                                  <p style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="head__txt" style={{ width: '40%' }}>
                                      {t("Lab")}:
                                    </span>
                                    <span className="val__txt" style={{ width: '60%', display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column' }}>
                                      {selectedRowDetails.certificateNo && (
                                        <span>{selectedRowDetails.certificateNo}{" "}</span>
                                      )}
                                      <span style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: "wrap" }}>
                                        {selectedRowDetails.certificateImage && (
                                          <img
                                            src={ImageIcon}
                                            alt=""
                                            title="View Certificate Image"
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              window.open(
                                                selectedRowDetails.certificateImage,
                                                "_blank"
                                              )
                                            }
                                          />
                                        )}
                                        <span
                                          className="linkText"
                                          onClick={() =>
                                            handleCertificateOpen(
                                              selectedRowDetails
                                            )
                                          }
                                        >
                                          {selectedRowDetails.txtCertificate}
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Matched Pair Stock")}#:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltCrown}
                                    </span>
                                  </p>
                                </div>

                                <div
                                  style={{
                                    backgroundColor: "#f5f5f5",
                                    padding: "0 16px",
                                    flex: 1,
                                  }}
                                >
                                  <p>
                                    <span className="head__txt">
                                      {t("Seller")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.dealerCompany}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Stock")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtStockNo}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Phone")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.dealerPhone}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Location")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.dealerLocation}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Updated")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.modified}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                {/* View DiamondImage Modal */}

                <Modal
                  title=""
                  visible={isModalVisibleFullscreen}
                  className="fullscreen__modal image-modal"
                  onCancel={handleCancelFullscreen}
                  footer={false}
                  width={500}
                //style={{ top: 30 }}
                >
                  <div className="thimage__slider text-center">
                    <img
                      src={
                        selectedRowDetails?.imageBigShape
                          ? selectedRowDetails?.imageBigShape
                          : selectedRowDetails?.imageFileName
                          ? selectedRowDetails?.imageFileName
                          : ""
                      }
                      alt=""
                      className="img-fluid"
                      height={"400px"}
                      width="300"
                    />
                  </div>
                </Modal>
                <Modal
                  title={
                    <React.Fragment>
                      <h4 className="d-flex mb-0">
                        {t("Message to")}
                        <h4 className="linkTextWithoutPointer mx-2 mb-0">
                          {selectedRowDetails.dealerCompany
                            ? selectedRowDetails.dealerCompany
                            : ""}
                        </h4>
                      </h4>
                    </React.Fragment>
                  }
                  className="modalvdiamond__section"
                  centered
                  visible={visible1}
                  onOk={() => setVisible1(false)}
                  onCancel={() => setVisible1(false)}
                  width={600}
                  footer={[
                    <Button key="back" onClick={handleCancel1}>
                      {t("Cancel")}
                    </Button>,
                    <Button
                      key="submit"
                      type="primary"
                      onClick={handleMsgValidation}
                      loading={msgLoading}
                    >
                      {t("Send")}
                    </Button>,
                  ]}
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          <div className="row">
                            <div className="col-lg-12 ">
                              <p>
                                {t("Contact the dealer regarding")}.{" "}
                                <span
                                  className="linkTextWithoutPointer"
                                  href="#"
                                >
                                  {selectedRowDetails.txtStockNo} .
                                </span>
                              </p>
                            </div>
                            <div className="col-lg-12">
                              <div class="input__block">
                                <textarea
                                  id=""
                                  name=""
                                  rows="6"
                                  cols="50"
                                  placeholder={t("Write your message here...")}
                                  class=""
                                  value={msgData}
                                  onChange={(e) => {
                                    setMsgData(e.target.value);
                                    setMsgError("");
                                  }}
                                ></textarea>
                                {msgError ? (
                                  <div className="text-danger">{msgError}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                <Modal
                  title={t("Video")}
                  className="modalvdiamond__section"
                  centered
                  visible={visible2}
                  onOk={() => setVisible2(false)}
                  onCancel={() => setVisible2(false)}
                  width={350}
                  style={{ zIndex: "1000" }}
                  footer={[
                    <Button key="back" onClick={handleCancel2}>
                      {t("Close")}
                    </Button>,
                  ]}
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          <div className="row">
                            <div className="col-lg-12 mt-4">
                              <iframe
                                id="VideoIframesrc"
                                src="https://certimage.s3-accelerate.amazonaws.com/V360_viewers/v4.0/Vision360.html?surl=https://certimage.s3-accelerate.amazonaws.com/V360/_v4.0/&amp;d=YG-2493&amp;sv=0,1,2,3,4,5"
                                class="VideoIframe"
                              ></iframe>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                <Modal
                  title={t("Video/Images")}
                  className="modalconsupld__section"
                  centered
                  width={(() => {
                    if (isVideo && selectedRowDetails.videoFileName) {
                      const videoUrl = selectedRowDetails.videoFileName.toLowerCase();
                      const urlPath = videoUrl.split('?')[0];
                      const isDirectVideo = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.flv', '.wmv'].some(ext => urlPath.endsWith(ext));
                      // Wider modal for embedded videos (YouTube, Vimeo, etc.), narrower for direct video files
                      return isDirectVideo ? 600 : 900;
                    }
                    // Wider modal for images
                    return selectedRowDetails.imageFileName ? 700 : 450;
                  })()}
                  visible={videoImageModal}
                  onCancel={() => handleCloseVideoImageModal()}
                  footer={[
                    <Button onClick={() => handleCloseVideoImageModal()}>
                      {t("Cancel")}
                    </Button>,
                  ]}
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          <div className="row">
                            {isVideo ? (
                              selectedRowDetails.videoFileName ? (
                                (() => {
                                  const videoUrl = selectedRowDetails.videoFileName.toLowerCase();
                                  const urlPath = videoUrl.split('?')[0];
                                  // Check if it's a direct video file (mp4, webm, ogg, mov, etc.)
                                  const isDirectVideo = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.flv', '.wmv'].some(ext => urlPath.endsWith(ext));
                                  // Dynamic height based on video type: embedded videos (16:9), direct files (auto)
                                  const iframeHeight = isDirectVideo ? "auto" : "500px";
                                  return !isDirectVideo ? (
                                    <iframe
                                      src={selectedRowDetails.videoFileName}
                                      height={iframeHeight}
                                      width="100%"
                                      title="diamond-video"
                                      style={{ aspectRatio: "16/9" }}
                                    ></iframe>
                                  ) : (
                                    <video
                                      title="diamond-video"
                                      className="VideoIframe"
                                      src={selectedRowDetails.videoFileName}
                                      controls
                                      id="product_video"
                                      style={{ width: "100%", height: "auto" }}
                                    ></video>
                                  );
                                })()
                              ) : (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                              )
                            ) : selectedRowDetails.imageFileName ? (
                              <img
                                src={selectedRowDetails.imageFileName}
                                alt="img-diamond"
                                style={{ width: "100%", height: "auto", maxHeight: "600px" }}
                              />
                            ) : (
                              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                {/* Image zoom modal */}
                <Modal
                  title={isEmail ? "Email Diamond Certificate" : "Image"}
                  className="modalvdiamond__section image__zoommodal"
                  centered
                  visible={visible3}
                  onOk={() => setVisible3(false)}
                  onCancel={() => setVisible3(false)}
                  width={600}
                  footer={
                    isEmail
                      ? null
                      : [
                        <Button key="back"> {t("Print")} </Button>,
                        <Button
                          key="submit"
                          type="primary"
                          onClick={handleOpenIsEmail}
                        >
                          {t("Email")}
                        </Button>,
                      ]
                  }
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          {isEmail ? (
                            <React.Fragment>
                              <div className="row">
                                <div className="col-lg-12 input__block">
                                  <label> {t("Name")}: </label>
                                  <input
                                    type={"text"}
                                    name="Name"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.Name}
                                  />
                                  {errorEmailCertificat.Name ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["Name"]}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-lg-12 input__block">
                                  <label> {t("Email")}: </label>
                                  <input
                                    type={"text"}
                                    name="Email"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.Email}
                                  />
                                  {errorEmailCertificat.Email ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["Email"]}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-lg-12 input__block">
                                  <label> {t("Friend's Name")}: </label>
                                  <input
                                    type={"text"}
                                    name="FriendsName"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.FriendsName}
                                  />
                                  {errorEmailCertificat.FriendsName ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["FriendsName"]}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-lg-12 input__block">
                                  <label> {t("Friend's Email")}: </label>
                                  <input
                                    type={"text"}
                                    name="FriendsEmail"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.FriendsEmail}
                                  />
                                  {errorEmailCertificat.FriendsEmail ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["FriendsEmail"]}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-lg-12 input__block">
                                  <label> {t("Comments")}: </label>
                                  <input
                                    type={"text"}
                                    name="Comments"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.Comments}
                                  />
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-lg-12 ant-modal-footer ">
                                  <Button
                                    type={"primary"}
                                    loading={EmailLoading}
                                    onClick={() => handleCertificateEmailSend()}
                                  >
                                    {t("Submit")}
                                  </Button>
                                  <Button onClick={handleCloseIsEmail}>
                                    {t("Cancel")}
                                  </Button>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : (
                            <div className="row">
                              <div className="col-lg-12 mt-4">
                                <div className="image__zoom">
                                  <img
                                    src={selectedRowDetails.imageFileName}
                                    alt="cer-img"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>

                {/* Modal Request Certificate  */}
                <Modal
                  title={t("Request Diamond Certificate")}
                  visible={requestCertModal}
                  style={{ top: 70 }}
                  className="request_info"
                  onCancel={closeCertInfoModal}
                  footer={[
                    <Button key="back" onClick={closeCertInfoModal}>
                      {t("Cancel")}
                    </Button>,
                    <Button
                      key="submit"
                      loading={requestCertModalLoading}
                      type="primary"
                      onClick={handleSubmitRequestCert}
                    >
                      {t("Request")}
                    </Button>,
                  ]}
                >
                  <div className="row">
                    <div class="col-md-12">
                      <div className="table__block">
                        <div className="row p-0 border-0 form__fields mh-auto">
                          <div className="col-md-6">
                            <div className="input__block">
                              <label>
                                {t("Name")} <span className="mandatory">*</span>{" "}
                              </label>
                              <input
                                type="text"
                                value={certInfoData.name}
                                className={
                                  certInfoValidation.nameVal && "border__red"
                                }
                                onChange={(e) =>
                                  handleCertInfoChange(e, "name", "input")
                                }
                              />
                              {certInfoValidation.nameVal && (
                                <p className="error-color-red">
                                  {certInfoValidation.nameVal}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input__block">
                              <label>
                                {t("E-Mail Address")}{" "}
                                <span className="mandatory">*</span>{" "}
                              </label>
                              <input
                                type="text"
                                value={certInfoData.email}
                                className={
                                  certInfoValidation.emailVal && "border__red"
                                }
                                onChange={(e) =>
                                  handleCertInfoChange(e, "email", "input")
                                }
                              />
                              {certInfoValidation.emailVal && (
                                <p className="error-color-red">
                                  {certInfoValidation.emailVal}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input__block">
                              <label>
                                {t("Phone Number")}{" "}
                                <span className="mandatory">*</span>{" "}
                              </label>
                              <input
                                type="text"
                                value={certInfoData.phoneNumber}
                                className={
                                  certInfoValidation.phoneNumberVal &&
                                  "border__red"
                                }
                                onChange={(e) =>
                                  handleCertInfoChange(
                                    e,
                                    "phoneNumber",
                                    "input"
                                  )
                                }
                              />
                              {certInfoValidation.phoneNumberVal && (
                                <p className="error-color-red">
                                  {certInfoValidation.phoneNumberVal}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="input__block">
                              <label>{t("Comments")}</label>
                              <textarea
                                value={certInfoData.comments}
                                onChange={(e) =>
                                  handleCertInfoChange(e, "comments", "input")
                                }
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                {/* End */}

              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ColorDiamondSearch;
